(() => {
  const mobileMenu = document.querySelector(".wp-mobile-menu");
  const offerPopup = document.querySelector("[data-offer-popup]");
  const offerClose = document.querySelector("[data-offer-close]");
  const offerProgress = document.querySelector("[data-offer-progress]");
  const rareOffer = document.querySelector("[data-rare-offer]");
  const rareOfferCloseButtons = document.querySelectorAll("[data-rare-offer-close]");
  const rareOfferProgress = document.querySelector("[data-rare-offer-progress]");
  const offerDelayMs = 20000;
  const offerVisibleMs = 22000;
  const offerCooldownMs = 24 * 60 * 60 * 1000;
  const rareOfferChance = 0.01;
  const rareOfferCooldownMs = 14 * 24 * 60 * 60 * 1000;
  const offerStorageKey = "wonderpodsOfferLastDismissed";
  const rareOfferStorageKey = "wonderpodsRareOfferLastSeen";
  // Keep the module and WASM on the same immutable release; CDN @latest caches can disagree.
  let offerTimer;
  let offerAutoHideTimer;
  let offerProgressFrame;
  let rareOfferTimer;
  let rareOfferAutoHideTimer;
  let rareOfferProgressFrame;
  let offerDismissed = false;
  let rareOfferDismissed = false;
  let offerScheduled = false;

  const closeMobileMenu = () => {
    if (!mobileMenu) {
      return;
    }

    mobileMenu.removeAttribute("open");
  };

  const setupHeroCarousel = () => {
    const hero = document.querySelector(".wp-hero");
    const slider = hero ? hero.querySelector("[data-hero-slider]") : null;

    if (!hero || !slider) {
      return;
    }

    const slides = Array.from(slider.querySelectorAll(".wp-hero-slide"));
    const dots = Array.from(hero.querySelectorAll("[data-hero-dot]"));
    const previousButton = hero.querySelector("[data-hero-prev]");
    const nextButton = hero.querySelector("[data-hero-next]");

    if (!slides.length) {
      return;
    }

    let activeIndex = 0;
    let scrollFrame;
    let requestedIndex = null;
    let settleTimer;

    const prefersReducedMotion = () => (
      window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );

    const setActiveSlide = (index) => {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      if (previousButton) previousButton.disabled = activeIndex === 0;
      if (nextButton) nextButton.disabled = activeIndex === slides.length - 1;

      slides.forEach((slide, slideIndex) => {
        if (slideIndex === activeIndex) {
          slide.setAttribute("aria-current", "true");
        } else {
          slide.removeAttribute("aria-current");
        }
      });

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;
        dot.classList.toggle("is-active", isActive);

        if (isActive) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });
    };

    const getNearestSlideIndex = () => {
      const sliderRect = slider.getBoundingClientRect();
      const sliderStyles = window.getComputedStyle(slider);
      const scrollPaddingLeft = parseFloat(sliderStyles.scrollPaddingLeft) || 0;
      const targetLeft = sliderRect.left + scrollPaddingLeft;
      let nearestIndex = 0;
      let nearestDistance = Infinity;

      slides.forEach((slide, slideIndex) => {
        const slideDistance = Math.abs(slide.getBoundingClientRect().left - targetLeft);

        if (slideDistance < nearestDistance) {
          nearestDistance = slideDistance;
          nearestIndex = slideIndex;
        }
      });

      return nearestIndex;
    };

    const goToSlide = (index) => {
      const nextIndex = Math.max(0, Math.min(index, slides.length - 1));
      requestedIndex = nextIndex;

      slides[nextIndex].scrollIntoView({
        behavior: prefersReducedMotion() ? "auto" : "smooth",
        block: "nearest",
        inline: "start"
      });
      setActiveSlide(nextIndex);
      clearTimeout(settleTimer);
      settleTimer = setTimeout(() => { requestedIndex = null; setActiveSlide(getNearestSlideIndex()); }, 600);
    };

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener("click", () => {
        goToSlide(dotIndex);
      });
    });

    if (previousButton) {
      previousButton.addEventListener("click", () => {
        goToSlide(activeIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener("click", () => {
        goToSlide(activeIndex + 1);
      });
    }

    slider.addEventListener("keydown", (event) => {
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        goToSlide(activeIndex - 1);
      }

      if (event.key === "ArrowRight") {
        event.preventDefault();
        goToSlide(activeIndex + 1);
      }
    });

    slider.addEventListener("scroll", () => {
      if (scrollFrame) {
        window.cancelAnimationFrame(scrollFrame);
      }

      scrollFrame = window.requestAnimationFrame(() => {
        scrollFrame = null;
        if (requestedIndex === null) setActiveSlide(getNearestSlideIndex());
      });
    }, { passive: true });
    ['pointerdown', 'touchstart', 'wheel'].forEach((type) => slider.addEventListener(type, () => {
      clearTimeout(settleTimer);
      requestedIndex = null;
      setActiveSlide(getNearestSlideIndex());
    }, { passive: true }));

    setActiveSlide(0);
  };

  let railControlId = 0;
  const createRailControls = (rail, label) => {
    if (!rail.id) {
      let id;
      do { id = `WonderbookRail-${++railControlId}`; } while (document.getElementById(id));
      rail.id = id;
    }
    const controls = rail.matches('.wp-people-rail')
      ? rail.closest('section').querySelector('[data-recipient-controls]') || document.createElement('div')
      : document.createElement('div');
    controls.classList.add('wp-scroll-controls');
    controls.setAttribute('role', 'group');
    controls.setAttribute('aria-label', `Bla i ${label}`);
    controls.hidden = true;
    const rtl = getComputedStyle(rail).direction === 'rtl';
    const buttons = [-1, 1].map((direction) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = direction < 0 ? 'wp-scroll-controls__previous' : 'wp-scroll-controls__next';
      button.setAttribute('aria-controls', rail.id);
      button.setAttribute('aria-label', `${direction < 0 ? "Forrige" : "Neste"} bøker i ${label}`);
      const arrow = document.createElement('span');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = direction * (rtl ? -1 : 1) < 0 ? '←' : '→';
      button.append(arrow);
      return button;
    });
    controls.replaceChildren(...buttons);
    const shell = document.createElement('div');
    shell.className = 'wp-scroll-shell';
    shell.hidden = rail.hidden;
    rail.before(shell);
    shell.append(rail, controls);
    const alignControls = () => {
      const image = rail.querySelector('.wp-product-card__media, .wp-product-character__portrait, .wp-person-card img, .wp-moment-rail img')
        || rail.querySelector('img') || rail;
      const bounds = image.getBoundingClientRect();
      if (bounds.height) shell.style.setProperty('--wp-scroll-arrow-top', `${bounds.top - shell.getBoundingClientRect().top + bounds.height / 2}px`);
    };
    if (!rail.hasAttribute('aria-label') && !rail.hasAttribute('aria-labelledby')) rail.setAttribute('aria-label', label);
    if (!rail.hasAttribute('role') && !rail.matches('nav, table')) rail.setAttribute('role', 'group');
    return { controls, previous: buttons[0], next: buttons[1], shell, alignControls };
  };

  const setupHorizontalRailControls = () => {
    const selectors = [
      '.wp-people-rail', '.wp-product-rail', '.wp-moment-rail', '.wp-occasion-rail',
      '.wp-product-characters__grid', '.wp-product-media-gallery__grid',
      '.wp-template-section .wp-rte table', '.shopify-policy__body table', '.wp-product-rte table'
    ];
    document.querySelectorAll(selectors.join(',')).forEach((rail) => {
      if (rail.dataset.scrollControlsReady) return;
      rail.dataset.scrollControlsReady = 'true';
      const heading = rail.closest('section, .wp-product-media-gallery')?.querySelector('h2, h3');
      const label = rail.getAttribute('aria-label')
        || (rail.matches('.wp-product-characters__grid') ? 'saved characters'
          : rail.matches('table') ? 'tabellkolonner' : heading?.textContent.trim() || 'bøker');
      const { controls, previous, next, shell, alignControls } = createRailControls(rail, label);
      const originalTabIndex = rail.getAttribute('tabindex');
      let frame;
      let motionFrame = 0;
      let targetPosition = null;
      let savedSnapType = '';
      let savedScrollBehavior = '';
      let maximum = 0;
      let viewportWidth = 0;
      let sign = 1;
      let snapPoints = [];
      let motionPosition = 0;
      let velocity = 0;
      let lastMotionTime = 0;
      const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const clampPosition = (position) => Math.max(0, Math.min(maximum, position));
      const currentPosition = () => clampPosition(rail.scrollLeft * sign);
      const syncBounds = () => {
        const position = targetPosition ?? currentPosition();
        previous.disabled = position <= 2;
        next.disabled = position >= maximum - 2;
      };
      const cancelMotion = () => {
        cancelAnimationFrame(motionFrame);
        motionFrame = 0;
        if (targetPosition !== null) {
          rail.style.scrollSnapType = savedSnapType;
          rail.style.scrollBehavior = savedScrollBehavior;
        }
        targetPosition = null;
        velocity = 0;
        syncBounds();
      };
      const nearestPoint = (points, position) => points.reduce((nearest, point) => (
        Math.abs(point - position) < Math.abs(nearest - position) ? point : nearest
      ));
      const sync = () => {
        shell.hidden = rail.hidden;
        const style = getComputedStyle(rail);
        viewportWidth = rail.clientWidth;
        maximum = Math.max(0, rail.scrollWidth - viewportWidth);
        sign = style.direction === 'rtl' ? -1 : 1;
        const scrollable = viewportWidth > 0 && /auto|scroll/.test(style.overflowX) && maximum > 2;
        controls.hidden = !scrollable;
        shell.classList.toggle('has-overflow', scrollable);
        if (scrollable) rail.tabIndex = 0;
        else if (originalTabIndex === null) rail.removeAttribute('tabindex');
        else rail.setAttribute('tabindex', originalTabIndex);
        snapPoints = [];
        if (scrollable) {
          const bounds = rail.getBoundingClientRect();
          const viewportLeft = bounds.left + rail.clientLeft;
          const position = currentPosition();
          const paddingStart = parseFloat(sign < 0 ? style.scrollPaddingRight : style.scrollPaddingLeft) || 0;
          const paddingEnd = parseFloat(sign < 0 ? style.scrollPaddingLeft : style.scrollPaddingRight) || 0;
          Array.from(rail.children).forEach((card) => {
            if (!card.getClientRects().length) return;
            const cardStyle = getComputedStyle(card);
            const alignment = cardStyle.scrollSnapAlign.split(' ').pop();
            if (!alignment || alignment === 'none') return;
            const cardBounds = card.getBoundingClientRect();
            const marginStart = parseFloat(sign < 0 ? cardStyle.scrollMarginRight : cardStyle.scrollMarginLeft) || 0;
            const marginEnd = parseFloat(sign < 0 ? cardStyle.scrollMarginLeft : cardStyle.scrollMarginRight) || 0;
            const offset = position + (sign < 0
              ? viewportLeft + viewportWidth - cardBounds.right : cardBounds.left - viewportLeft);
            const start = offset - marginStart;
            const end = offset + cardBounds.width + marginEnd;
            const point = alignment === 'center' ? (start + end - viewportWidth - paddingStart + paddingEnd) / 2
              : alignment === 'end' ? end - viewportWidth + paddingEnd : start - paddingStart;
            snapPoints.push(clampPosition(point));
          });
          if (snapPoints.length) {
            snapPoints.push(0, maximum);
            snapPoints.sort((a, b) => a - b);
            snapPoints = snapPoints.filter((point, index, points) => !index || point - points[index - 1] > 1);
          }
        }
        if (targetPosition !== null) {
          targetPosition = snapPoints.length ? nearestPoint(snapPoints, clampPosition(targetPosition)) : clampPosition(targetPosition);
          motionPosition = currentPosition();
          if (!scrollable) cancelMotion();
        }
        syncBounds();
        alignControls();
      };
      const scheduleSync = () => {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => { frame = null; sync(); });
      };
      const animate = (now) => {
        if (targetPosition === null) return;
        const elapsed = Math.min(0.064, Math.max(0, now - lastMotionTime) / 1000);
        lastMotionTime = now;
        // A critically damped spring keeps momentum through repeated taps without overshooting.
        const offset = motionPosition - targetPosition;
        const frequency = 24;
        const coefficient = velocity + frequency * offset;
        const decay = Math.exp(-frequency * elapsed);
        const position = targetPosition + (offset + coefficient * elapsed) * decay;
        velocity = (velocity - frequency * coefficient * elapsed) * decay;
        motionPosition = clampPosition(Math.max(Math.min(motionPosition, targetPosition), Math.min(Math.max(motionPosition, targetPosition), position)));
        const settled = reduceMotion.matches || (Math.abs(motionPosition - targetPosition) < 0.35 && Math.abs(velocity) < 8);
        rail.scrollLeft = (settled ? targetPosition : motionPosition) * sign;
        if (settled) cancelMotion();
        else motionFrame = requestAnimationFrame(animate);
      };
      const move = (direction, edge = false) => {
        if (controls.hidden) return;
        const base = targetPosition ?? currentPosition();
        const requested = clampPosition(edge ? (direction < 0 ? 0 : maximum) : base + viewportWidth * 0.85 * direction);
        const candidates = snapPoints.filter((point) => direction * (point - base) > 2);
        const destination = !edge && candidates.length ? nearestPoint(candidates, requested) : requested;
        if (targetPosition === null) {
          savedSnapType = rail.style.scrollSnapType;
          savedScrollBehavior = rail.style.scrollBehavior;
          motionPosition = currentPosition();
          rail.style.scrollSnapType = 'none';
          rail.style.scrollBehavior = 'auto';
        }
        if (velocity * (destination - motionPosition) < 0) velocity = 0;
        targetPosition = destination;
        syncBounds();
        if (reduceMotion.matches) {
          rail.scrollLeft = destination * sign;
          cancelMotion();
        } else if (!motionFrame) {
          lastMotionTime = performance.now();
          motionFrame = requestAnimationFrame(animate);
        }
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      rail.addEventListener('keydown', (event) => {
        if (event.target !== rail || controls.hidden || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') move(event.key === 'Home' ? -1 : 1, true);
        else move((event.key === 'ArrowLeft' ? -1 : 1) * (getComputedStyle(rail).direction === 'rtl' ? -1 : 1));
      });
      rail.addEventListener('scroll', () => { if (targetPosition === null) syncBounds(); }, { passive: true });
      ['pointerdown', 'touchstart', 'wheel'].forEach((type) => rail.addEventListener(type, cancelMotion, { passive: true }));
      rail.addEventListener('load', scheduleSync, true);
      window.addEventListener('resize', scheduleSync);
      const observer = 'ResizeObserver' in window ? new ResizeObserver(scheduleSync) : null;
      const observeCards = () => {
        observer?.disconnect();
        observer?.observe(rail);
        Array.from(rail.children).forEach((card) => observer?.observe(card));
        scheduleSync();
      };
      new MutationObserver(observeCards).observe(rail, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
      observeCards();
      sync();
    });
  };

  const imagePreloads = new Map();
  const canPreloadImages = () => {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    return document.readyState === "complete" && !document.hidden && !connection?.saveData
      && !["slow-2g", "2g", "3g"].includes(connection?.effectiveType);
  };
  const preloadImage = ({ src, srcset = "", sizes = "" }, priority = "low") => {
    if (!src) return Promise.resolve(false);
    // Include the viewport so a later interaction after resizing can select a new candidate.
    const key = JSON.stringify([src, srcset, sizes, srcset ? window.innerWidth : 0, srcset ? window.innerHeight : 0, srcset ? window.devicePixelRatio : 1]);
    const cached = imagePreloads.get(key);
    if (cached) {
      if (priority !== "low") cached.image.fetchPriority = priority;
      return cached.promise;
    }
    const image = new Image();
    image.decoding = "async";
    image.fetchPriority = priority;
    const promise = new Promise((resolve) => {
      image.onload = () => {
        if (image.decode) image.decode().catch(() => {}).then(() => resolve(true));
        else resolve(true);
      };
      image.onerror = () => { imagePreloads.delete(key); resolve(false); };
    });
    imagePreloads.set(key, { image, promise });
    if (sizes) image.sizes = sizes;
    if (srcset) image.srcset = srcset;
    image.src = src;
    return promise;
  };

  const setupProductPhotoGallery = ({ rotator, stage, cover, items, thumbnails, thumbnailButtons, reduceMotion }) => {
    const controller = new AbortController();
    const listen = (target, type, handler, options = {}) => target.addEventListener(type, handler, { ...options, signal: controller.signal });
    const count = items.length;
    const wrap = (index) => (index + count) % count;
    let currentIndex = Math.max(0, items.findIndex((item) => String(item.id) === cover.dataset.mediaId));
    let requestedIndex = currentIndex;
    let targetPosition = currentIndex + 1;
    let navigating = false;
    let gesture = null;
    let suppressClickUntil = 0;
    let scrollFrame = null;
    let dragFrame = null;
    let settleTimer = null;
    let width = 0;
    const initialSizes = cover.getAttribute("sizes") || "";
    const track = document.createElement("div");
    track.className = "wp-product-gallery-track";
    track.tabIndex = 0;
    track.setAttribute("aria-label", "Produktbilder. Sveip eller bruk venstre og høyre piltast.");
    const slides = [];

    // Keep actual image elements in the scrolling surface. Touch gestures never
    // wait for a source replacement or a JavaScript-driven drag animation.
    [count - 1, ...items.map((_, index) => index), 0].forEach((itemIndex, position) => {
      const item = items[itemIndex];
      const clone = position === 0 || position === count + 1;
      const slide = document.createElement("div");
      slide.className = "wp-product-gallery-slide";
      const image = !clone && itemIndex === currentIndex ? cover : document.createElement("img");
      if (image !== cover) {
        image.alt = item.coverAlt || cover.alt;
        image.width = cover.width;
        image.height = cover.height;
        image.loading = "lazy";
        image.decoding = "async";
        image.fetchPriority = "low";
        if (item.coverSizes || initialSizes) image.sizes = item.coverSizes || initialSizes;
        if (item.coverSrcset) image.srcset = item.coverSrcset;
        image.src = item.cover;
      }
      image.draggable = false;
      slide.setAttribute("aria-hidden", String(clone || itemIndex !== currentIndex));
      slide.append(image);
      track.append(slide);
      slides.push({ slide, image, itemIndex, clone });
    });
    stage.append(track);
    stage.classList.add("wp-product-gallery-stage", "wp-product-gallery-native");
    stage.setAttribute("role", "group");
    stage.setAttribute("aria-roledescription", "carousel");
    stage.setAttribute("aria-label", "Produktbilder");
    rotator.dataset.productHeroMediaReady = "true";

    const controls = document.createElement("div");
    controls.className = "wp-product-gallery-controls";
    controls.setAttribute("role", "group");
    controls.setAttribute("aria-label", "Produktbilder");
    const previous = document.createElement("button");
    previous.type = "button";
    previous.textContent = "‹";
    previous.setAttribute("aria-label", "Forrige bilde");
    const counter = document.createElement("span");
    counter.className = "wp-product-gallery-controls__count";
    counter.setAttribute("aria-live", "polite");
    counter.setAttribute("aria-atomic", "true");
    const next = document.createElement("button");
    next.type = "button";
    next.textContent = "›";
    next.setAttribute("aria-label", "Neste bilde");
    controls.append(previous, counter, next);
    rotator.insertAdjacentElement("afterend", controls);

    const warmNeighbors = () => {
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (document.hidden || connection?.saveData || ["slow-2g", "2g", "3g"].includes(connection?.effectiveType)) return;
      slides.forEach(({ image, itemIndex }) => {
        if ([currentIndex, wrap(currentIndex - 1), wrap(currentIndex + 1)].includes(itemIndex)) {
          image.loading = "eager";
          image.decode?.().catch(() => {});
        }
      });
    };
    const syncSelection = (revealThumbnail = true) => {
      counter.textContent = `${currentIndex + 1} / ${count}`;
      counter.setAttribute("aria-label", `Bilde ${currentIndex + 1} av ${count}`);
      slides.forEach(({ slide, itemIndex, clone }) => slide.setAttribute("aria-hidden", String(clone || itemIndex !== currentIndex)));
      let active;
      thumbnailButtons.forEach((button) => {
        const selected = Number(button.dataset.productMediaIndex) === currentIndex;
        button.setAttribute("aria-pressed", String(selected));
        if (selected) active = button;
      });
      if (active && revealThumbnail && thumbnails.clientWidth && thumbnails.clientHeight) {
        const rail = thumbnails.getBoundingClientRect();
        const selected = active.getBoundingClientRect();
        const left = selected.left < rail.left ? selected.left - rail.left : Math.max(0, selected.right - rail.right);
        const top = selected.top < rail.top ? selected.top - rail.top : Math.max(0, selected.bottom - rail.bottom);
        if (left || top) thumbnails.scrollBy({ left, top, behavior: "instant" });
      }
      warmNeighbors();
    };
    const position = () => Math.max(0, Math.min(count + 1, Math.round(track.scrollLeft / width)));
    const settle = () => {
      if (gesture || !width) return;
      window.clearTimeout(settleTimer);
      const settled = position();
      // Ignore an old scrollend delivered just after another arrow/thumbnail request.
      if (navigating && Math.abs(track.scrollLeft - targetPosition * width) > 1) return;
      currentIndex = wrap(settled - 1);
      requestedIndex = currentIndex;
      targetPosition = currentIndex + 1;
      navigating = false;
      if (settled === 0 || settled === count + 1) track.scrollTo({ left: targetPosition * width, behavior: "instant" });
      track.style.removeProperty("scroll-snap-type");
      syncSelection();
    };
    const navigate = (index, direction = 0) => {
      // Crossing the duplicate end slide is visually identical and keeps looping short.
      if (targetPosition === 0 || targetPosition === count + 1) {
        track.scrollTo({ left: (requestedIndex + 1) * width, behavior: "instant" });
      }
      const nextIndex = wrap(index);
      targetPosition = nextIndex + 1;
      if (direction > 0 && requestedIndex === count - 1 && nextIndex === 0) targetPosition = count + 1;
      if (direction < 0 && requestedIndex === 0 && nextIndex === count - 1) targetPosition = 0;
      requestedIndex = nextIndex;
      navigating = true;
      slides.filter(({ itemIndex }) => itemIndex === nextIndex).forEach(({ image }) => { image.loading = "eager"; });
      track.scrollTo({ left: targetPosition * width, behavior: reduceMotion ? "instant" : "smooth" });
      if (reduceMotion) settle();
    };
    const navigateBy = (direction) => navigate(requestedIndex + direction, direction);
    listen(previous, "click", () => navigateBy(-1));
    listen(next, "click", () => navigateBy(1));
    thumbnailButtons.forEach((button) => {
      listen(button, "pointerdown", (event) => {
        if (!event.isPrimary || event.button !== 0 || event.pointerType === "touch") return;
        event.preventDefault();
        button.focus({ preventScroll: true });
      });
      listen(button, "click", () => navigate(Number(button.dataset.productMediaIndex)));
    });
    listen(track, "keydown", (event) => {
      if (!["ArrowLeft", "ArrowRight", "Home", "End", "Enter", " "].includes(event.key)) return;
      event.preventDefault();
      if (event.key === "Home") navigate(0);
      else if (event.key === "End") navigate(count - 1);
      else navigateBy(event.key === "ArrowLeft" ? -1 : 1);
    });
    listen(track, "click", (event) => {
      if (Date.now() < suppressClickUntil) { event.preventDefault(); return; }
      navigateBy(1);
    });
    listen(track, "dragstart", (event) => event.preventDefault());
    listen(track, "scroll", () => {
      suppressClickUntil = Date.now() + 400;
      if (scrollFrame === null) scrollFrame = window.requestAnimationFrame(() => {
        scrollFrame = null;
        if (!width) return;
        const nextIndex = wrap(position() - 1);
        if (nextIndex !== currentIndex) { currentIndex = nextIndex; syncSelection(false); }
      });
      // Fallback for browsers without scrollend; reset only after scrolling stops.
      if (!("onscrollend" in track)) {
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(settle, 140);
      }
    }, { passive: true });
    listen(track, "scrollend", settle, { passive: true });

    const endGesture = (cancelled = false) => {
      if (!gesture) return;
      const ended = gesture;
      gesture = null;
      if (dragFrame !== null) window.cancelAnimationFrame(dragFrame);
      dragFrame = null;
      stage.classList.remove("is-dragging");
      if (track.hasPointerCapture?.(ended.id)) track.releasePointerCapture(ended.id);
      if (ended.mouse && ended.horizontal) {
        const recent = ended.lastTime && ended.upTime - ended.lastTime < 100;
        const distance = Math.abs(ended.dx);
        const commit = !cancelled && (distance > Math.min(60, width * 0.15) || (distance > 16 && recent && Math.abs(ended.velocity) > 0.45));
        const destination = ended.index + (commit ? (ended.dx < 0 ? 1 : -1) : 0);
        // Keep snapping disabled until the smooth scroll reaches its destination.
        // Restoring it here would immediately jump to the closest slide on release.
        requestedIndex = ended.index;
        navigate(destination, commit ? (ended.dx < 0 ? 1 : -1) : 0);
      } else if (ended.mouse && track.style.getPropertyValue("scroll-snap-type") === "none") {
        navigate(ended.index);
      }
    };
    listen(track, "pointerdown", (event) => {
      if (!event.isPrimary) { suppressClickUntil = Date.now() + 700; endGesture(true); return; }
      if (event.button !== 0) return;
      navigating = false;
      currentIndex = wrap(position() - 1);
      requestedIndex = currentIndex;
      targetPosition = currentIndex + 1;
      gesture = { id: event.pointerId, mouse: event.pointerType === "mouse", x: event.clientX, y: event.clientY,
        scroll: track.scrollLeft, index: currentIndex, dx: 0, lastX: event.clientX, lastTime: event.timeStamp, velocity: 0 };
      // Touch/pen scrolling belongs entirely to the browser: no capture, preventDefault or rAF writes.
      if (gesture.mouse) track.scrollTo({ left: track.scrollLeft, behavior: "instant" });
    }, { passive: true });
    listen(track, "pointermove", (event) => {
      if (!gesture || gesture.id !== event.pointerId) return;
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      if (Math.max(Math.abs(dx), Math.abs(dy)) > 8) suppressClickUntil = Date.now() + 700;
      if (!gesture.mouse) return;
      if (!gesture.axis && Math.max(Math.abs(dx), Math.abs(dy)) > 8) gesture.axis = Math.abs(dx) > Math.abs(dy) * 1.25 ? "x" : "y";
      if (gesture.axis !== "x") return;
      if (!gesture.horizontal) {
        gesture.horizontal = true;
        track.style.setProperty("scroll-snap-type", "none");
        stage.classList.add("is-dragging");
        track.setPointerCapture?.(event.pointerId);
      }
      const elapsed = event.timeStamp - gesture.lastTime;
      if (elapsed > 0) gesture.velocity = (event.clientX - gesture.lastX) / elapsed;
      gesture.lastX = event.clientX;
      gesture.lastTime = event.timeStamp;
      gesture.dx = dx;
      if (dragFrame === null) dragFrame = window.requestAnimationFrame(() => {
        dragFrame = null;
        if (gesture?.horizontal) track.scrollLeft = gesture.scroll - gesture.dx;
      });
    }, { passive: true });
    listen(track, "pointerup", (event) => {
      if (gesture?.id !== event.pointerId) return;
      gesture.upTime = event.timeStamp;
      endGesture();
    }, { passive: true });
    listen(track, "pointercancel", () => { suppressClickUntil = Date.now() + 700; endGesture(true); }, { passive: true });
    listen(track, "lostpointercapture", () => endGesture(true));
    const resize = () => {
      // Preserve subpixels: integer clientWidth drifts away from later snap points.
      const nextWidth = track.getBoundingClientRect().width;
      if (!nextWidth || nextWidth === width) return;
      endGesture(true);
      width = nextWidth;
      targetPosition = currentIndex + 1;
      requestedIndex = currentIndex;
      navigating = false;
      track.scrollTo({ left: targetPosition * width, behavior: "instant" });
    };
    const observer = typeof ResizeObserver !== "undefined" ? new ResizeObserver(resize) : null;
    observer?.observe(track);
    listen(window, "resize", resize);
    if (thumbnails) thumbnails.hidden = false;
    resize();
    syncSelection();
    listen(document, "shopify:section:unload", (event) => {
      if (!event.target.contains(rotator)) return;
      controller.abort();
      observer?.disconnect();
      window.clearTimeout(settleTimer);
      if (scrollFrame !== null) window.cancelAnimationFrame(scrollFrame);
      if (dragFrame !== null) window.cancelAnimationFrame(dragFrame);
      track.replaceWith(cover);
      controls.remove();
      stage.classList.remove("wp-product-gallery-stage", "wp-product-gallery-native", "is-dragging");
      ["role", "aria-roledescription", "aria-label"].forEach((name) => stage.removeAttribute(name));
      delete rotator.dataset.productHeroMediaReady;
    });
  };

  const setupProductHeroMediaRotators = () => {
    const rotators = Array.from(document.querySelectorAll("[data-world-cup-product-media-rotator], [data-product-hero-media-rotator]"));

    if (!rotators.length) {
      return;
    }

    const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    rotators.forEach((rotator) => {
      const isWorldCupRotator = rotator.matches("[data-world-cup-product-media-rotator]");
      const readyKey = isWorldCupRotator ? "worldCupProductMediaReady" : "productHeroMediaReady";

      if (rotator.dataset[readyKey] === "true") {
        return;
      }

      const stage = rotator.querySelector("[data-product-hero-media-stage]") || rotator.querySelector(".wp-world-cup-product-shop-media__stage") || rotator;
      const cover = rotator.querySelector("[data-product-hero-media-image]") || rotator.querySelector("[data-world-cup-product-media-cover]");
      const portrait = rotator.querySelector("[data-world-cup-product-media-portrait]");
      const coverTitle = isWorldCupRotator ? rotator.closest("[data-product-template]")?.querySelector("[data-world-cup-cover-title]") : null;
      const mediaData = rotator.querySelector("[data-product-hero-media]") || rotator.querySelector("[data-world-cup-product-media]");
      const thumbnails = !isWorldCupRotator ? rotator.parentElement.querySelector("[data-product-thumbnails]") : null;
      const thumbnailButtons = thumbnails ? Array.from(thumbnails.querySelectorAll("[data-product-media-index]")) : [];

      if (!stage || !cover || !mediaData) {
        return;
      }

      let items = [];

      try {
        items = JSON.parse(mediaData.textContent || "[]").filter((item) => (
          item.cover && (!portrait || item.portrait)
        ));
      } catch (error) {
        items = [];
      }

      if (items.length < 2) {
        return;
      }

      if (!isWorldCupRotator && typeof stage.scrollTo === "function") {
        setupProductPhotoGallery({ rotator, stage, cover, items, thumbnails, thumbnailButtons, reduceMotion });
        return;
      }

      rotator.dataset[readyKey] = "true";
      stage.setAttribute("role", "button");
      stage.setAttribute("tabindex", "0");
      stage.setAttribute("aria-label", rotator.dataset.productMediaNextLabel || "Vis neste eksempel på personlig tilpasning");

      const firstInterval = Number.parseInt(rotator.dataset.productHeroMediaFirstInterval || rotator.dataset.worldCupProductMediaFirstInterval || "", 10);
      const nextInterval = Number.parseInt(rotator.dataset.productHeroMediaInterval || rotator.dataset.worldCupProductMediaInterval || "", 10);
      const firstIntervalMs = Number.isFinite(firstInterval) ? Math.max(2200, firstInterval) : 4800;
      const nextIntervalMs = Number.isFinite(nextInterval) ? Math.max(1800, nextInterval) : 3200;
      const fadeMs = reduceMotion ? 0 : 140;
      let currentIndex = Math.max(0, items.findIndex((item) => String(item.id) === cover.dataset.mediaId));
      let requestedIndex = currentIndex;
      let rotationTimeout = null;
      let fadeTimeout = null;
      let isAdvancing = false;
      let advanceGeneration = 0;
      let userInteracted = false;
      let gesture = null;
      let suppressClickUntil = 0;
      let swipeAnimations = [];
      let dragFrame = null;
      let dragOffset = 0;
      const galleryImages = [cover, portrait].filter(Boolean);
      const initialCoverSizes = cover.getAttribute("sizes") || "";
      const initialPortraitSizes = portrait?.getAttribute("sizes") || "";

      const controls = document.createElement("div");
      controls.className = "wp-product-gallery-controls";
      controls.setAttribute("role", "group");
      controls.setAttribute("aria-label", "Produktbilder");
      const previous = document.createElement("button");
      previous.type = "button";
      previous.textContent = "‹";
      previous.setAttribute("aria-label", "Forrige bilde");
      const counter = document.createElement("span");
      counter.className = "wp-product-gallery-controls__count";
      counter.setAttribute("aria-live", "polite");
      counter.setAttribute("aria-atomic", "true");
      const next = document.createElement("button");
      next.type = "button";
      next.textContent = "›";
      next.setAttribute("aria-label", "Neste bilde");
      controls.append(previous, counter, next);
      rotator.insertAdjacentElement("afterend", controls);
      stage.classList.add("wp-product-gallery-stage");
      cover.draggable = false;
      if (portrait) portrait.draggable = false;

      const syncThumbnails = () => {
        counter.textContent = `${currentIndex + 1} / ${items.length}`;
        counter.setAttribute("aria-label", `Bilde ${currentIndex + 1} av ${items.length}`);
        let activeThumbnail;
        thumbnailButtons.forEach((button) => {
          const active = Number(button.dataset.productMediaIndex) === currentIndex;
          button.setAttribute("aria-pressed", String(active));
          if (active) activeThumbnail = button;
        });
        if (!activeThumbnail || thumbnails.hidden || !thumbnails.clientWidth || !thumbnails.clientHeight) return;
        // Scroll only the rail, on whichever axis the responsive layout overflows.
        const rail = thumbnails.getBoundingClientRect();
        const selected = activeThumbnail.getBoundingClientRect();
        const leftEdge = rail.left + thumbnails.clientLeft + 2;
        const topEdge = rail.top + thumbnails.clientTop + 2;
        const rightEdge = rail.left + thumbnails.clientLeft + thumbnails.clientWidth - 2;
        const bottomEdge = rail.top + thumbnails.clientTop + thumbnails.clientHeight - 2;
        const left = thumbnails.scrollWidth > thumbnails.clientWidth
          ? (selected.left < leftEdge ? selected.left - leftEdge : Math.max(0, selected.right - rightEdge)) : 0;
        const top = thumbnails.scrollHeight > thumbnails.clientHeight
          ? (selected.top < topEdge ? selected.top - topEdge : Math.max(0, selected.bottom - bottomEdge)) : 0;
        // Keep visible thumbnails still; reveal offscreen ones without moving the page.
        if (left || top) thumbnails.scrollBy({ left, top, behavior: "auto" });
      };

      const preloadItem = (item, priority = "low") => {
        if (!item) return Promise.resolve(false);
        const images = [{ src: item.cover, srcset: item.coverSrcset, sizes: item.coverSizes || initialCoverSizes }];
        if (portrait && item.portrait) images.push({ src: item.portrait, srcset: item.portraitSrcset, sizes: item.portraitSizes || initialPortraitSizes });
        return Promise.all(images.map((source) => preloadImage(source, priority))).then((loaded) => loaded.every(Boolean));
      };

      const setItem = (item) => {
        const sizes = item.coverSizes || initialCoverSizes;
        if (sizes) cover.sizes = sizes;
        else cover.removeAttribute("sizes");
        cover.fetchPriority = "auto";
        if (item.coverSrcset) {
          cover.srcset = item.coverSrcset;
        } else {
          cover.removeAttribute("srcset");
        }

        cover.src = item.cover;

        if (item.coverAlt) {
          cover.alt = item.coverAlt;
        }

        if (coverTitle && item.coverTitle) {
          coverTitle.textContent = item.coverTitle;
        }

        if (portrait && item.portrait) {
          const portraitSizes = item.portraitSizes || initialPortraitSizes;
          if (portraitSizes) portrait.sizes = portraitSizes;
          else portrait.removeAttribute("sizes");
          if (item.portraitSrcset) portrait.srcset = item.portraitSrcset;
          else portrait.removeAttribute("srcset");
          portrait.src = item.portrait;
        }

        if (portrait && item.portraitAlt) {
          portrait.alt = item.portraitAlt;
        }
      };

      const clearScheduledAdvance = () => {
        if (rotationTimeout) {
          window.clearTimeout(rotationTimeout);
          rotationTimeout = null;
        }
      };

      const stopImageMotion = () => {
        swipeAnimations.forEach((animation) => animation.cancel());
        swipeAnimations = [];
      };
      const clearImageDrag = () => {
        if (dragFrame !== null) window.cancelAnimationFrame(dragFrame);
        dragFrame = null;
        dragOffset = 0;
        galleryImages.forEach((image) => image.style.removeProperty("translate"));
      };
      const settleImageDrag = () => {
        const offset = dragOffset;
        stopImageMotion();
        clearImageDrag();
        if (!reduceMotion && offset) {
          swipeAnimations = galleryImages.map((image) => image.animate?.([
            { translate: `${offset}px 0` }, { translate: "0 0" }
          ], { duration: 200, easing: "cubic-bezier(0.22, 0.68, 0, 1)" })).filter(Boolean);
        }
      };
      const paintImageDrag = () => {
        dragFrame = null;
        if (!gesture || gesture.axis !== "x" || reduceMotion) return;
        // Only the artwork follows the finger; the frame and layout stay fixed.
        const limit = Math.min(96, gesture.width * 0.24);
        dragOffset = Math.max(-limit, Math.min(limit, gesture.dx));
        galleryImages.forEach((image) => image.style.setProperty("translate", `${dragOffset}px 0`));
      };
      const finishAdvance = (nextIndex, nextItem, swipeDirection = 0) => {
        const distance = Math.max(24, Math.min(72, Math.abs(dragOffset) || 48));
        stopImageMotion();
        clearImageDrag();
        setItem(nextItem);
        currentIndex = nextIndex;
        syncThumbnails();
        stage.classList.remove("is-fading");
        stage.setAttribute("aria-busy", "false");
        if (swipeDirection && !reduceMotion) {
          swipeAnimations = galleryImages.map((image) => image.animate?.([
            { translate: `${swipeDirection * distance}px 0` },
            { translate: "0 0" }
          ], { duration: 240, easing: "cubic-bezier(0.22, 0.68, 0, 1)" })).filter(Boolean);
        }
        if (canPreloadImages()) {
          preloadItem(items[(currentIndex + 1) % items.length]);
        }
        isAdvancing = false;

        if (!reduceMotion && !thumbnailButtons.length && !userInteracted) {
          scheduleNext();
        }
      };

      const advanceTo = (nextIndex, swipeDirection = 0) => {
        if (!Number.isInteger(nextIndex) || nextIndex < 0 || nextIndex >= items.length) return;
        requestedIndex = nextIndex;
        isAdvancing = true;
        const generation = ++advanceGeneration;
        clearScheduledAdvance();
        stopImageMotion();
        if (!swipeDirection) clearImageDrag();
        if (fadeTimeout) { window.clearTimeout(fadeTimeout); fadeTimeout = null; }
        stage.classList.remove("is-fading");
        stage.setAttribute("aria-busy", "true");
        const nextItem = items[nextIndex];

        preloadItem(nextItem, "auto").then((loaded) => {
          if (generation !== advanceGeneration) return;
          if (!loaded) {
            settleImageDrag();
            requestedIndex = currentIndex;
            isAdvancing = false;
            stage.setAttribute("aria-busy", "false");
            counter.textContent = "Kunne ikke laste. Prøv igjen.";
            counter.setAttribute("aria-label", "Bildet kunne ikke lastes. Prøv igjen.");
            return;
          }
          // User navigation has no artificial wait after the image is decoded.
          if (userInteracted || fadeMs === 0) {
            finishAdvance(nextIndex, nextItem, swipeDirection);
            return;
          }
          stage.classList.add("is-fading");

          fadeTimeout = window.setTimeout(() => {
            fadeTimeout = null;
            if (generation !== advanceGeneration) return;
            finishAdvance(nextIndex, nextItem);
          }, fadeMs);
        });
      };
      const advanceToNext = () => {
        if (!isAdvancing) advanceTo((currentIndex + 1) % items.length);
      };

      const scheduleNext = () => {
        const intervalMs = currentIndex === 0 ? firstIntervalMs : nextIntervalMs;

        clearScheduledAdvance();
        if (userInteracted || !canPreloadImages()) return;
        rotationTimeout = window.setTimeout(() => {
          rotationTimeout = null;
          advanceToNext();
        }, intervalMs);
      };

      const pauseRotation = () => {
        // A gesture takes ownership even if an automatic change is still loading.
        if (!userInteracted && isAdvancing) {
          advanceGeneration++;
          if (fadeTimeout) { window.clearTimeout(fadeTimeout); fadeTimeout = null; }
          requestedIndex = currentIndex;
          isAdvancing = false;
          stage.classList.remove("is-fading");
          stage.setAttribute("aria-busy", "false");
        }
        userInteracted = true;
        clearScheduledAdvance();
      };
      const navigate = (index, swipeDirection = 0) => {
        pauseRotation();
        advanceTo((index + items.length) % items.length, swipeDirection);
      };
      const navigateBy = (direction, fromSwipe = false) => {
        pauseRotation();
        navigate(requestedIndex + direction, fromSwipe ? direction : 0);
      };
      previous.addEventListener("click", () => navigateBy(-1));
      next.addEventListener("click", () => navigateBy(1));
      stage.addEventListener("click", (event) => {
        if (Date.now() < suppressClickUntil) {
          event.preventDefault();
          return;
        }
        navigateBy(1);
      });
      stage.addEventListener("dragstart", (event) => event.preventDefault());
      const resetGesture = (settle = true) => {
        const pointerId = gesture?.id;
        gesture = null;
        if (dragFrame !== null) window.cancelAnimationFrame(dragFrame);
        dragFrame = null;
        stage.classList.remove("is-dragging");
        if (settle) settleImageDrag();
        if (pointerId !== undefined && stage.hasPointerCapture?.(pointerId)) stage.releasePointerCapture(pointerId);
      };
      stage.addEventListener("pointerdown", (event) => {
        if (!event.isPrimary) {
          suppressClickUntil = Date.now() + 700;
          resetGesture();
          return;
        }
        if (event.button !== 0) return;
        pauseRotation();
        stopImageMotion();
        clearImageDrag();
        gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, dx: 0, width: stage.clientWidth,
          lastX: event.clientX, lastTime: event.timeStamp, velocity: 0, axis: null };
        stage.setPointerCapture?.(event.pointerId);
      });
      stage.addEventListener("pointermove", (event) => {
        if (!gesture || gesture.id !== event.pointerId) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        if (!gesture.axis && Math.max(Math.abs(dx), Math.abs(dy)) > 8) {
          gesture.axis = Math.abs(dx) > Math.abs(dy) * 1.25 ? "x" : "y";
        }
        if (gesture.axis) suppressClickUntil = Date.now() + 700;
        if (gesture.axis !== "x") return;
        stage.classList.add("is-dragging");
        const elapsed = event.timeStamp - gesture.lastTime;
        if (elapsed > 0) gesture.velocity = (event.clientX - gesture.lastX) / elapsed;
        gesture.lastX = event.clientX;
        gesture.lastTime = event.timeStamp;
        gesture.dx = dx;
        if (!reduceMotion && dragFrame === null) dragFrame = window.requestAnimationFrame(paintImageDrag);
        const direction = dx < 0 ? 1 : -1;
        if (gesture.warmedDirection !== direction) {
          gesture.warmedDirection = direction;
          preloadItem(items[(requestedIndex + direction + items.length) % items.length], "auto");
        }
      });
      stage.addEventListener("pointerup", (event) => {
        if (!gesture || gesture.id !== event.pointerId) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        const threshold = Math.min(56, Math.max(32, gesture.width * 0.12));
        const velocity = event.timeStamp - gesture.lastTime < 80 ? gesture.velocity : 0;
        const flick = Math.abs(dx) >= 16 && Math.abs(velocity) > 0.45 && Math.sign(velocity) === Math.sign(dx);
        const isSwipe = gesture.axis === "x" && (Math.abs(dx) >= threshold || flick) && Math.abs(dx) > Math.abs(dy) * 1.25;
        if (gesture.axis || Math.max(Math.abs(dx), Math.abs(dy)) > 10) suppressClickUntil = Date.now() + 700;
        resetGesture(!isSwipe);
        if (isSwipe) navigateBy(dx < 0 ? 1 : -1, true);
      });
      stage.addEventListener("pointercancel", () => {
        suppressClickUntil = Date.now() + 700;
        resetGesture();
      });
      stage.addEventListener("lostpointercapture", () => { if (gesture) resetGesture(); });
      const warmOnIntent = (element, getIndex) => {
        const warm = () => {
          if (canPreloadImages()) preloadItem(items[getIndex()]);
        };
        element.addEventListener("pointerenter", warm);
        element.addEventListener("focus", warm);
      };
      warmOnIntent(stage, () => (currentIndex + 1) % items.length);
      thumbnailButtons.forEach((button) => {
        button.addEventListener("pointerdown", (event) => {
          if (!event.isPrimary || event.button !== 0 || event.pointerType === "touch") return;
          // Mouse focus must not scroll the rail or the sticky page before selection.
          event.preventDefault();
          button.focus({ preventScroll: true });
        });
        button.addEventListener("click", () => navigate(Number(button.dataset.productMediaIndex)));
        warmOnIntent(button, () => Number(button.dataset.productMediaIndex));
      });
      if (thumbnails) thumbnails.hidden = false;
      syncThumbnails();
      stage.addEventListener("keydown", (event) => {
        if (!["Enter", " ", "ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) {
          return;
        }

        event.preventDefault();
        if (event.key === "Home") navigate(0);
        else if (event.key === "End") navigate(items.length - 1);
        else navigateBy(event.key === "ArrowLeft" ? -1 : 1);
      });

      const startRotation = () => {
        if (isAdvancing || fadeTimeout || !canPreloadImages()) return;
        preloadItem(items[(currentIndex + 1) % items.length]).then(() => {
          if (!reduceMotion && !thumbnailButtons.length && !userInteracted && !isAdvancing && !fadeTimeout) scheduleNext();
        });
      };
      if (document.readyState === "complete") startRotation();
      else window.addEventListener("load", startRotation, { once: true });
      document.addEventListener("visibilitychange", () => {
        if (document.hidden) clearScheduledAdvance();
        else startRotation();
      });
    });
  };

  const updateProgress = (progressElement, startedAt, durationMs, frameSetter) => {
    if (!progressElement) {
      return;
    }

    const elapsed = Math.min(Date.now() - startedAt, durationMs);
    const remainingRatio = Math.max(0, 1 - elapsed / durationMs);
    progressElement.style.transform = `scaleX(${remainingRatio})`;

    if (remainingRatio > 0) {
      frameSetter(window.requestAnimationFrame(() => {
        updateProgress(progressElement, startedAt, durationMs, frameSetter);
      }));
    }
  };

  const clearOfferLifeTimers = () => {
    if (offerTimer) {
      window.clearTimeout(offerTimer);
    }
    if (offerAutoHideTimer) {
      window.clearTimeout(offerAutoHideTimer);
    }
    if (offerProgressFrame) {
      window.cancelAnimationFrame(offerProgressFrame);
    }
  };

  const clearRareOfferLifeTimers = () => {
    if (rareOfferTimer) {
      window.clearTimeout(rareOfferTimer);
    }
    if (rareOfferAutoHideTimer) {
      window.clearTimeout(rareOfferAutoHideTimer);
    }
    if (rareOfferProgressFrame) {
      window.cancelAnimationFrame(rareOfferProgressFrame);
    }
  };

  const hideOfferPopup = () => {
    const wasVisible = offerPopup && !offerPopup.hidden;
    offerDismissed = true;
    clearOfferLifeTimers();
    if (offerPopup) {
      offerPopup.hidden = true;
    }
    if (wasVisible) {
      rememberOfferDismissed();
    }
  };

  const showOfferPopup = () => {
    if (offerPopup && !offerDismissed && !isOfferRecentlyDismissed()) {
      const startedAt = Date.now();
      offerPopup.hidden = false;
      if (offerProgress) {
        offerProgress.style.transform = "scaleX(1)";
        updateProgress(offerProgress, startedAt, offerVisibleMs, (frame) => {
          offerProgressFrame = frame;
        });
      }
      offerAutoHideTimer = window.setTimeout(hideOfferPopup, offerVisibleMs);
    }
  };

  const holdOfferPopup = () => {
    if (!offerPopup || offerPopup.hidden) return;
    clearOfferLifeTimers();
    offerPopup.classList.add("is-interacting");
  };

  const hideRareOffer = () => {
    const wasVisible = rareOffer && !rareOffer.hidden;
    rareOfferDismissed = true;
    clearRareOfferLifeTimers();
    if (rareOffer) {
      rareOffer.hidden = true;
    }
    if (wasVisible) {
      rememberOfferDismissed();
    }
  };

  const showRareOffer = () => {
    if (!rareOffer || rareOfferDismissed || isOfferRecentlyDismissed()) {
      return;
    }

    const startedAt = Date.now();
    rareOffer.hidden = false;

    try {
      window.localStorage.setItem(rareOfferStorageKey, String(Date.now()));
    } catch (error) {
      // Local storage can be unavailable in private browsing; the offer should still work.
    }

    if (rareOfferProgress) {
      rareOfferProgress.style.transform = "scaleX(1)";
      updateProgress(rareOfferProgress, startedAt, offerVisibleMs, (frame) => {
        rareOfferProgressFrame = frame;
      });
    }
    rareOfferAutoHideTimer = window.setTimeout(hideRareOffer, offerVisibleMs);
  };

  const holdRareOffer = () => {
    if (!rareOffer || rareOffer.hidden) return;
    clearRareOfferLifeTimers();
    rareOffer.classList.add("is-interacting");
  };

  const shouldShowRareOffer = () => {
    if (!rareOffer) {
      return false;
    }

    try {
      const lastSeen = Number(window.localStorage.getItem(rareOfferStorageKey) || 0);
      if (lastSeen && Date.now() - lastSeen < rareOfferCooldownMs) {
        return false;
      }
    } catch (error) {
      return Math.random() < rareOfferChance;
    }

    return Math.random() < rareOfferChance;
  };

  const rememberOfferDismissed = () => {
    try {
      window.localStorage.setItem(offerStorageKey, String(Date.now()));
    } catch (error) {
      // Ignore storage failures; popup behavior can still rely on in-memory state.
    }
  };

  const isOfferRecentlyDismissed = () => {
    try {
      const lastDismissed = Number(window.localStorage.getItem(offerStorageKey) || 0);
      return Boolean(lastDismissed && Date.now() - lastDismissed < offerCooldownMs);
    } catch (error) {
      return false;
    }
  };

  const scheduleOfferPopup = () => {
    if ((!offerPopup && !rareOffer) || offerScheduled || isOfferRecentlyDismissed()) {
      return;
    }

    // Start on the first homepage visit without requiring a deep scroll or another page view.
    offerScheduled = true;

    if (shouldShowRareOffer()) {
      rareOfferTimer = window.setTimeout(showRareOffer, offerDelayMs);
      return;
    }

    if (offerPopup) {
      offerTimer = window.setTimeout(showOfferPopup, offerDelayMs);
    }
  };

  const parseCents = (value, fallback = 0) => {
    const cents = Number(value);
    return Number.isFinite(cents) ? Math.max(0, Math.round(cents)) : fallback;
  };

  const getCurrencyCode = (container) => (
    container.dataset.currencyCode
    || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
    || "USD"
  );

  const formatMoneyFromCents = (cents, currencyCode) => {
    const safeCents = parseCents(cents);
    const hasCents = safeCents % 100 !== 0;

    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: "currency",
        currency: currencyCode,
        minimumFractionDigits: hasCents ? 2 : 0,
        maximumFractionDigits: 2
      }).format(safeCents / 100);
    } catch (error) {
      return `$${(safeCents / 100).toFixed(hasCents ? 2 : 0)}`;
    }
  };

  const setupProductVariantPricing = () => {
    const productTemplates = document.querySelectorAll("[data-product-template]");

    if (!productTemplates.length) {
      return;
    }

    productTemplates.forEach((productTemplate) => {
      const currencyCode = getCurrencyCode(productTemplate);
      const priceOutputs = Array.from(productTemplate.querySelectorAll("[data-product-price]"));
      const primaryPriceOutput = priceOutputs[0] || null;
      const variantSelect = productTemplate.querySelector("select[name='id']");
      const variantInput = productTemplate.querySelector("input[name='id']");
      const variantOptionInputs = Array.from(productTemplate.querySelectorAll("[data-variant-option]"));

      const getSelectedVariantDataset = () => {
        if (variantSelect && variantSelect.selectedOptions.length) {
          return variantSelect.selectedOptions[0].dataset;
        }

        const checkedVariantOption = variantOptionInputs.find((variantOptionInput) => variantOptionInput.checked);

        if (checkedVariantOption) {
          return checkedVariantOption.dataset;
        }

        return variantInput ? variantInput.dataset : {};
      };

      const syncVariantOptions = () => {
        if (!variantOptionInputs.length) {
          return;
        }

        const selectedValue = variantSelect
          ? variantSelect.value
          : (variantInput ? variantInput.value : "");

        variantOptionInputs.forEach((variantOptionInput) => {
          const isSelected = variantOptionInput.value === selectedValue;
          variantOptionInput.checked = isSelected;

          const variantOption = variantOptionInput.closest(".wp-product-format-option");

          if (variantOption) {
            variantOption.classList.toggle("is-selected", isSelected);
          }
        });
      };

      const getSelectedVariantPrice = () => {
        const selectedVariantDataset = getSelectedVariantDataset();

        if (selectedVariantDataset.variantPriceCents) {
          return parseCents(selectedVariantDataset.variantPriceCents, parseCents(primaryPriceOutput && primaryPriceOutput.dataset.priceCents));
        }

        return parseCents(primaryPriceOutput && primaryPriceOutput.dataset.priceCents);
      };

      const updateSelectedPrice = () => {
        const priceCents = getSelectedVariantPrice();

        priceOutputs.forEach((priceOutput) => {
          priceOutput.textContent = formatMoneyFromCents(priceCents, currencyCode);
          priceOutput.dataset.priceCents = String(priceCents);
        });

        syncVariantOptions();
      };

      updateSelectedPrice();

      if (variantSelect) {
        variantSelect.addEventListener("change", updateSelectedPrice);
      }

      variantOptionInputs.forEach((variantOptionInput) => {
        variantOptionInput.addEventListener("change", () => {
          if (!variantOptionInput.checked) {
            return;
          }

          if (variantSelect) {
            variantSelect.value = variantOptionInput.value;
            variantSelect.dispatchEvent(new Event("change", { bubbles: true }));
            return;
          }

          if (variantInput) {
            variantInput.value = variantOptionInput.value;
            variantInput.dataset.variantPriceCents = variantOptionInput.dataset.variantPriceCents || "";
          }

          updateSelectedPrice();
        });
      });
    });
  };

  const setupWorldCupCountryPickers = () => {
    const countryPickers = document.querySelectorAll("[data-world-cup-country-picker]");
    const englandFlag = "\u{1F3F4}\u{E0067}\u{E0062}\u{E0065}\u{E006E}\u{E0067}\u{E007F}";
    const scotlandFlag = "\u{1F3F4}\u{E0067}\u{E0062}\u{E0073}\u{E0063}\u{E0074}\u{E007F}";
    const walesFlag = "\u{1F3F4}\u{E0067}\u{E0062}\u{E0077}\u{E006C}\u{E0073}\u{E007F}";

    const countrySuggestions = [
      { name: "Afghanistan", flag: "🇦🇫" },
      { name: "Albania", flag: "🇦🇱" },
      { name: "Algeria", flag: "🇩🇿" },
      { name: "Andorra", flag: "🇦🇩" },
      { name: "Angola", flag: "🇦🇴" },
      { name: "Argentina", flag: "🇦🇷" },
      { name: "Armenia", flag: "🇦🇲" },
      { name: "Australia", flag: "🇦🇺" },
      { name: "Austria", flag: "🇦🇹" },
      { name: "Belgium", flag: "🇧🇪" },
      { name: "Bolivia", flag: "🇧🇴" },
      { name: "Bosnia and Herzegovina", flag: "🇧🇦" },
      { name: "Brazil", flag: "🇧🇷" },
      { name: "Cabo Verde", flag: "🇨🇻" },
      { name: "Cameroon", flag: "🇨🇲" },
      { name: "Canada", flag: "🇨🇦" },
      { name: "Chile", flag: "🇨🇱" },
      { name: "China", flag: "🇨🇳" },
      { name: "Colombia", flag: "🇨🇴" },
      { name: "Costa Rica", flag: "🇨🇷" },
      { name: "Croatia", flag: "🇭🇷" },
      { name: "Denmark", flag: "🇩🇰" },
      { name: "Dominican Republic", flag: "🇩🇴" },
      { name: "Ecuador", flag: "🇪🇨" },
      { name: "Egypt", flag: "🇪🇬" },
      { name: "El Salvador", flag: "🇸🇻" },
      { name: "England", flag: englandFlag },
      { name: "France", flag: "🇫🇷" },
      { name: "Germany", flag: "🇩🇪" },
      { name: "Ghana", flag: "🇬🇭" },
      { name: "Greece", flag: "🇬🇷" },
      { name: "Guatemala", flag: "🇬🇹" },
      { name: "Haiti", flag: "🇭🇹" },
      { name: "Honduras", flag: "🇭🇳" },
      { name: "India", flag: "🇮🇳" },
      { name: "Ireland", flag: "🇮🇪" },
      { name: "Italy", flag: "🇮🇹" },
      { name: "Ivory Coast", flag: "🇨🇮" },
      { name: "Jamaica", flag: "🇯🇲" },
      { name: "Japan", flag: "🇯🇵" },
      { name: "Mexico", flag: "🇲🇽" },
      { name: "Morocco", flag: "🇲🇦" },
      { name: "Netherlands", flag: "🇳🇱" },
      { name: "New Zealand", flag: "🇳🇿" },
      { name: "Nigeria", flag: "🇳🇬" },
      { name: "Norway", flag: "🇳🇴" },
      { name: "Panama", flag: "🇵🇦" },
      { name: "Paraguay", flag: "🇵🇾" },
      { name: "Peru", flag: "🇵🇪" },
      { name: "Poland", flag: "🇵🇱" },
      { name: "Portugal", flag: "🇵🇹" },
      { name: "Puerto Rico", flag: "🇵🇷" },
      { name: "Scotland", flag: scotlandFlag },
      { name: "Senegal", flag: "🇸🇳" },
      { name: "South Africa", flag: "🇿🇦" },
      { name: "South Korea", flag: "🇰🇷" },
      { name: "Spain", flag: "🇪🇸" },
      { name: "Sweden", flag: "🇸🇪" },
      { name: "Switzerland", flag: "🇨🇭" },
      { name: "Trinidad and Tobago", flag: "🇹🇹" },
      { name: "Turkey", flag: "🇹🇷" },
      { name: "Ukraine", flag: "🇺🇦" },
      { name: "United States", flag: "🇺🇸" },
      { name: "Uruguay", flag: "🇺🇾" },
      { name: "Venezuela", flag: "🇻🇪" },
      { name: "Wales", flag: walesFlag }
    ];

    const normalizeCountryName = (value) => value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();

    countryPickers.forEach((countryPicker) => {
      const otherInput = countryPicker.querySelector("[data-world-cup-country-other]");
      const customCountryInput = countryPicker.querySelector("[data-world-cup-country-custom]");
      const customSelectedOption = countryPicker.querySelector("[data-world-cup-country-custom-option]");
      const customSelectedFlag = countryPicker.querySelector("[data-world-cup-country-custom-flag]");
      const customSelectedName = countryPicker.querySelector("[data-world-cup-country-custom-name]");
      const suggestionList = countryPicker.querySelector("[data-world-cup-country-suggestions]");
      const countryInputs = Array.from(countryPicker.querySelectorAll("[data-world-cup-country-option]"));
      const form = countryPicker.closest("form");

      if (!otherInput || !customCountryInput || !customSelectedOption || !customSelectedFlag || !customSelectedName || !suggestionList || !countryInputs.length || !form) {
        return;
      }

      const getCustomCountry = () => customCountryInput.value.trim();

      const setSuggestionVisibility = (isVisible) => {
        suggestionList.hidden = !isVisible;
        customCountryInput.setAttribute("aria-expanded", isVisible ? "true" : "false");
      };

      const hideSuggestions = () => {
        suggestionList.replaceChildren();
        setSuggestionVisibility(false);
      };

      const findExactCountry = (countryName) => {
        const normalizedCountry = normalizeCountryName(countryName);

        return countrySuggestions.find((country) => normalizeCountryName(country.name) === normalizedCountry);
      };

      const hideCustomSelection = () => {
        customSelectedOption.hidden = true;
        countryPicker.classList.remove("is-custom-country-selected");
      };

      const showCustomSelection = (countryName) => {
        const exactCountry = findExactCountry(countryName);
        const selectedName = exactCountry ? exactCountry.name : countryName;

        customSelectedFlag.textContent = exactCountry ? exactCountry.flag : "🏳️";
        customSelectedName.textContent = selectedName;
        customSelectedOption.setAttribute("aria-label", `Endre land fra ${selectedName}`);
        customSelectedOption.hidden = false;
        countryPicker.classList.add("is-custom-country-selected");
      };

      const setCustomCountry = (countryName) => {
        const selectedCountry = countryName.trim();

        if (!selectedCountry) {
          return;
        }

        customCountryInput.value = selectedCountry;
        otherInput.checked = true;
        showCustomSelection(selectedCountry);
        syncCustomCountry();
        hideSuggestions();
      };

      const showCustomCountryEditor = () => {
        hideCustomSelection();
        otherInput.checked = true;
        syncCustomCountry();

        try {
          customCountryInput.focus({ preventScroll: true });
        } catch (error) {
          customCountryInput.focus();
        }

        customCountryInput.select();
        renderSuggestions();
      };

      const renderSuggestions = () => {
        const query = normalizeCountryName(getCustomCountry());

        suggestionList.replaceChildren();

        if (!query) {
          setSuggestionVisibility(false);
          return;
        }

        const matches = countrySuggestions
          .filter((country) => normalizeCountryName(country.name).includes(query))
          .sort((firstCountry, secondCountry) => {
            const firstName = normalizeCountryName(firstCountry.name);
            const secondName = normalizeCountryName(secondCountry.name);
            const firstStarts = firstName.startsWith(query) ? 0 : 1;
            const secondStarts = secondName.startsWith(query) ? 0 : 1;

            if (firstStarts !== secondStarts) {
              return firstStarts - secondStarts;
            }

            return firstCountry.name.localeCompare(secondCountry.name);
          })
          .slice(0, 6);

        if (!matches.length) {
          setSuggestionVisibility(false);
          return;
        }

        matches.forEach((country) => {
          const button = document.createElement("button");
          const flag = document.createElement("span");
          const name = document.createElement("span");

          button.type = "button";
          button.className = "wp-world-cup-country-suggestion";
          button.dataset.countryName = country.name;
          button.setAttribute("role", "option");
          button.addEventListener("pointerdown", (event) => {
            event.preventDefault();
            setCustomCountry(country.name);
          });
          button.addEventListener("click", () => setCustomCountry(country.name));

          flag.textContent = country.flag;
          flag.setAttribute("aria-hidden", "true");
          name.textContent = country.name;

          button.append(flag, name);
          suggestionList.append(button);
        });

        setSuggestionVisibility(true);
      };

      const syncCustomCountry = () => {
        const isOtherSelected = otherInput.checked;
        const customCountry = getCustomCountry();
        const exactCountry = findExactCountry(customCountry);

        otherInput.value = exactCountry ? exactCountry.name : (customCountry || "Other");
        customCountryInput.required = isOtherSelected;
        countryPicker.classList.toggle("is-other-selected", isOtherSelected);

        if (!isOtherSelected || customCountry) {
          customCountryInput.setCustomValidity("");
        }
      };

      countryInputs.forEach((countryInput) => {
        countryInput.addEventListener("change", () => {
          syncCustomCountry();

          if (countryInput === otherInput) {
            customCountryInput.focus();
            renderSuggestions();
          } else {
            hideCustomSelection();
            hideSuggestions();
          }
        });
      });

      customCountryInput.addEventListener("input", () => {
        if (getCustomCountry()) {
          otherInput.checked = true;
        }

        hideCustomSelection();
        syncCustomCountry();
        renderSuggestions();
      });

      customCountryInput.addEventListener("change", () => {
        if (getCustomCountry()) {
          otherInput.checked = true;
        }

        hideCustomSelection();
        syncCustomCountry();
        renderSuggestions();
      });

      customSelectedOption.addEventListener("click", showCustomCountryEditor);

      customCountryInput.addEventListener("focus", renderSuggestions);

      customCountryInput.addEventListener("keydown", (event) => {
        const suggestionButtons = Array.from(suggestionList.querySelectorAll("button"));

        if (event.key === "Escape") {
          hideSuggestions();
          return;
        }

        if (event.key === "Enter" && suggestionButtons.length && !suggestionList.hidden) {
          event.preventDefault();
          setCustomCountry(suggestionButtons[0].dataset.countryName || getCustomCountry());
        }
      });

      document.addEventListener("click", (event) => {
        if (!countryPicker.contains(event.target)) {
          hideSuggestions();
        }
      });

      form.addEventListener("submit", (event) => {
        syncCustomCountry();

        if (!otherInput.checked || getCustomCountry()) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        customCountryInput.setCustomValidity("Choose or type a country.");
        customCountryInput.reportValidity();
      });

      syncCustomCountry();
    });
  };

  const setupProductStickyAtc = () => {
    const productTemplates = document.querySelectorAll("[data-product-template]");

    productTemplates.forEach((productTemplate) => {
      const stickyBar = productTemplate.querySelector("[data-sticky-mobile-atc]");
      const avatarFirst = stickyBar?.hasAttribute('data-avatar-first-sticky');
      const buyBox = productTemplate.querySelector("[data-sticky-buy-box]");
      const sourceAtc = productTemplate.querySelector("[data-sticky-source-atc]");
      const personalizePanel = productTemplate.querySelector("[data-product-personalize-panel]");
      const finalCta = productTemplate.querySelector(".wp-world-cup-product-final-cta .wp-button");
      const footerRegions = Array.from(document.querySelectorAll(".wp-newsletter, .wp-footer"));

      if (!stickyBar || !buyBox || !sourceAtc) {
        return;
      }

      let frame = null;

      const isMobileViewport = () => (
        window.matchMedia && window.matchMedia(avatarFirst || !personalizePanel ? "(max-width: 779px)" : "(max-width: 520px)").matches
      );

      const isElementInViewport = (element) => {
        const rect = element.getBoundingClientRect();

        return rect.height > 0 && rect.width > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
      };

      const setStickyBarHidden = (isHidden) => {
        stickyBar.hidden = isHidden;
      };

      const updateStickyBar = () => {
        frame = null;

        if (!isMobileViewport()) {
          setStickyBarHidden(true);
          return;
        }

        if (avatarFirst) {
          const pageActions = sourceAtc.closest('[data-character-product-actions]') || sourceAtc;
          const rect = pageActions.getBoundingClientRect();
          const headerBottom = Math.max(0, document.querySelector('.wp-header')?.getBoundingClientRect().bottom || 0);
          const visible = rect.width > 0 && rect.height > 0 && rect.top >= headerBottom && rect.bottom <= window.innerHeight;
          const editing = buyBox.contains(document.activeElement) && document.activeElement.matches('input, textarea, select');
          setStickyBarHidden(visible || editing || Boolean(document.querySelector('dialog[open]')));
          return;
        }

        const sourceAtcRect = sourceAtc.getBoundingClientRect();
        const hasPassedSourceAtc = sourceAtcRect.bottom < 0;
        const hasVisiblePageCta = isElementInViewport(sourceAtc) || (finalCta && isElementInViewport(finalCta));
        const hasVisibleFooter = footerRegions.some(isElementInViewport);
        if (personalizePanel) {
          const headerBottom = document.querySelector(".wp-header")?.getBoundingClientRect().bottom || 0;
          const hasVisibleAddToCart = sourceAtcRect.height > 0 && sourceAtcRect.top >= headerBottom && sourceAtcRect.bottom <= window.innerHeight;
          const isEditing = buyBox.contains(document.activeElement) && document.activeElement.matches("input, textarea, select");
          const isBuilderOpen = Boolean(document.querySelector('[data-story-builder][open]'));
          setStickyBarHidden(isBuilderOpen || hasVisibleAddToCart || hasVisibleFooter || isEditing);
        } else {
          setStickyBarHidden(!(hasPassedSourceAtc && !hasVisiblePageCta && !hasVisibleFooter));
        }
      };

      const requestUpdate = () => {
        if (frame) {
          return;
        }

        frame = window.requestAnimationFrame(updateStickyBar);
      };

      window.addEventListener("scroll", requestUpdate, { passive: true });
      window.addEventListener("resize", requestUpdate);
      window.addEventListener("orientationchange", requestUpdate);
      if (avatarFirst) {
        window.addEventListener('wonderbook:product-actions-updated', requestUpdate);
        document.querySelectorAll('dialog').forEach(dialog => new MutationObserver(requestUpdate).observe(dialog, { attributes: true, attributeFilter: ['open'] }));
        // Character creation is inserted after this shared product script loads.
        document.addEventListener('close', requestUpdate, true);
      }
      stickyBar.addEventListener("click", requestUpdate);
      if (personalizePanel) {
        const storyBuilder = document.querySelector('[data-story-builder]');
        if (storyBuilder) {
          new MutationObserver(requestUpdate).observe(storyBuilder, { attributes: true, attributeFilter: ['open'] });
        }
        buyBox.addEventListener("focusin", requestUpdate);
        buyBox.addEventListener("focusout", requestUpdate);
        if (typeof ResizeObserver !== "undefined") {
          const observer = new ResizeObserver(requestUpdate);
          observer.observe(buyBox);
          observer.observe(productTemplate);
        }
      }
      updateStickyBar();
    });
    document.querySelectorAll("[data-product-story-summary]").forEach((summary) => {
      const toggle = summary.querySelector("[data-product-read-more]");
      if (!toggle) return;
      summary.classList.add("is-collapsible");
      toggle.hidden = false;
      toggle.addEventListener("click", () => {
        const expanded = toggle.getAttribute("aria-expanded") !== "true";
        toggle.setAttribute("aria-expanded", String(expanded));
        summary.classList.toggle("is-expanded", expanded);
        toggle.textContent = expanded ? "Les mindre" : "Les mer";
      });
    });
  };

  const setupWorldCupHorizontalGestureLock = () => {
    const productTemplate = document.querySelector(".wp-product-template--world-cup[data-product-template]");

    if (!productTemplate) {
      return;
    }

    const customHorizontalGestureSelector = "[data-world-cup-preview-viewport]";
    const nativeHorizontalScrollerSelector = ".wp-world-cup-product-thumbnails__grid, .wp-product-rail, .wp-hero-slider, .wp-occasion-rail";
    let touchStartX = 0;
    let touchStartY = 0;
    let clampFrame = null;

    const getTargetElement = (target) => (
      target && target.nodeType === Node.ELEMENT_NODE
        ? target
        : target && target.parentElement
    );

    const clampRootHorizontalScroll = () => {
      const scrollingElement = document.scrollingElement || document.documentElement;
      const currentScrollY = window.scrollY
        || (scrollingElement && scrollingElement.scrollTop)
        || (document.documentElement && document.documentElement.scrollTop)
        || (document.body && document.body.scrollTop)
        || 0;

      if (scrollingElement && scrollingElement.scrollLeft) {
        scrollingElement.scrollLeft = 0;
      }

      if (document.documentElement && document.documentElement.scrollLeft) {
        document.documentElement.scrollLeft = 0;
      }

      if (document.body && document.body.scrollLeft) {
        document.body.scrollLeft = 0;
      }

      if (window.scrollX) {
        window.scrollTo(0, currentScrollY);
      }
    };

    const requestRootClamp = () => {
      if (clampFrame) {
        return;
      }

      clampFrame = window.requestAnimationFrame(() => {
        clampFrame = null;
        clampRootHorizontalScroll();
      });
    };

    const getNativeHorizontalScroller = (target) => {
      const targetElement = getTargetElement(target);

      if (!targetElement || !targetElement.closest) {
        return null;
      }

      const scroller = targetElement.closest(nativeHorizontalScrollerSelector);

      if (!scroller || scroller.scrollWidth <= scroller.clientWidth + 1) {
        return null;
      }

      return scroller;
    };

    const canNativeScrollerTakeGesture = (scroller, deltaX) => {
      if (!scroller) {
        return false;
      }

      const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;

      if (maxScrollLeft <= 1) {
        return false;
      }

      return deltaX > 0
        ? scroller.scrollLeft > 1
        : scroller.scrollLeft < maxScrollLeft - 1;
    };

    const isCustomHorizontalGesture = (target) => {
      const targetElement = getTargetElement(target);

      return Boolean(
        targetElement
        && targetElement.closest
        && targetElement.closest(customHorizontalGestureSelector)
      );
    };

    document.addEventListener("touchstart", (event) => {
      if (event.touches.length !== 1 || !productTemplate.contains(getTargetElement(event.target))) {
        return;
      }

      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, { capture: true, passive: true });

    document.addEventListener("touchmove", (event) => {
      if (event.touches.length !== 1 || !productTemplate.contains(getTargetElement(event.target))) {
        return;
      }

      const deltaX = event.touches[0].clientX - touchStartX;
      const deltaY = event.touches[0].clientY - touchStartY;
      const absoluteX = Math.abs(deltaX);

      if (absoluteX < 8 || absoluteX <= Math.abs(deltaY)) {
        return;
      }

      if (
        isCustomHorizontalGesture(event.target)
        || canNativeScrollerTakeGesture(getNativeHorizontalScroller(event.target), deltaX)
      ) {
        return;
      }

      if (event.cancelable) {
        event.preventDefault();
      }
      requestRootClamp();
    }, { capture: true, passive: false });

    document.addEventListener("touchend", requestRootClamp, { capture: true, passive: true });
    document.addEventListener("touchcancel", requestRootClamp, { capture: true, passive: true });
    window.addEventListener("scroll", requestRootClamp, { passive: true });
    window.addEventListener("orientationchange", requestRootClamp);
  };

  const setupWorldCupBallAnimation = () => {
    const balls = Array.from(document.querySelectorAll("[data-world-cup-ball]"));

    if (!balls.length) {
      return;
    }

    const prefersReducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    balls.forEach((ball) => {
      if (prefersReducedMotion) {
        ball.classList.remove("is-css-animated");
        return;
      }

      if (window.gsap) {
        if (ball.dataset.worldCupBallAnimated === "gsap") {
          return;
        }

        const motionX = Number.parseFloat(ball.dataset.motionX || "-12");
        const motionY = Number.parseFloat(ball.dataset.motionY || "-8");
        const motionRotation = Number.parseFloat(ball.dataset.motionRotation || "-18");
        const motionDuration = Number.parseFloat(ball.dataset.motionDuration || "4.8");

        ball.dataset.worldCupBallAnimated = "gsap";
        ball.classList.remove("is-css-animated");
        window.gsap.to(ball, {
          x: Number.isFinite(motionX) ? motionX : -12,
          y: Number.isFinite(motionY) ? motionY : -8,
          rotation: Number.isFinite(motionRotation) ? motionRotation : -18,
          duration: Number.isFinite(motionDuration) ? motionDuration : 4.8,
          ease: "sine.inOut",
          repeat: -1,
          yoyo: true
        });
        return;
      }

      if (!ball.dataset.worldCupBallAnimated) {
        ball.dataset.worldCupBallAnimated = "css";
        ball.classList.add("is-css-animated");
      }
    });
  };

  const setupWorldCupExampleFaders = () => {
    const faders = Array.from(document.querySelectorAll("[data-world-cup-example-fader], [data-product-example-fader]"));

    if (!faders.length) {
      return;
    }

    const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    faders.forEach((fader) => {
      if (fader.dataset.exampleFaderReady === "true") {
        return;
      }

      const slides = Array.from(fader.querySelectorAll("[data-world-cup-example-slide], [data-product-example-slide]"));

      if (!slides.length) {
        return;
      }

      fader.dataset.exampleFaderReady = "true";

      let activeIndex = slides.findIndex((slide) => slide.classList.contains("is-active"));

      if (activeIndex < 0) {
        activeIndex = 0;
      }

      const setActiveSlide = (index) => {
        activeIndex = (index + slides.length) % slides.length;

        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === activeIndex;

          slide.classList.toggle("is-active", isActive);

          if (isActive) {
            slide.setAttribute("aria-current", "true");
            slide.removeAttribute("aria-hidden");
          } else {
            slide.removeAttribute("aria-current");
            slide.setAttribute("aria-hidden", "true");
          }
        });
      };

      setActiveSlide(activeIndex);

      if (slides.length < 2 || reduceMotion) {
        return;
      }

      const configuredInterval = Number.parseInt(
        fader.dataset.worldCupExampleInterval || fader.dataset.productExampleInterval || "",
        10
      );
      const intervalMs = Number.isFinite(configuredInterval) ? Math.max(1500, configuredInterval) : 3000;

      window.setInterval(() => {
        setActiveSlide(activeIndex + 1);
      }, intervalMs);
    });
  };

  const setupWorldCupPreviewRails = () => {
    const tracks = Array.from(document.querySelectorAll("[data-world-cup-preview-track]"));

    if (!tracks.length) {
      return;
    }

    const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    tracks.forEach((track) => {
      if (track.dataset.previewRailReady === "true") {
        return;
      }

      const viewport = track.closest("[data-world-cup-preview-viewport]") || track.parentElement;
      const firstGroup = track.querySelector(".wp-world-cup-preview__group");

      if (!viewport || !firstGroup) {
        return;
      }

      const direction = track.dataset.previewDirection === "right" ? 1 : -1;
      const configuredSpeed = Number.parseFloat(track.dataset.previewSpeed || "");
      const speed = Number.isFinite(configuredSpeed) ? Math.max(12, configuredSpeed) : 46;
      const configuredDragSpeed = Number.parseFloat(track.dataset.previewDragSpeed || "");
      const configuredTouchDragSpeed = Number.parseFloat(track.dataset.previewTouchDragSpeed || "");
      const dragSpeed = Number.isFinite(configuredDragSpeed) ? Math.max(1, configuredDragSpeed) : 1.8;
      const touchDragSpeed = Number.isFinite(configuredTouchDragSpeed) ? Math.max(1, configuredTouchDragSpeed) : 2;
      let cycleWidth = 0;
      let position = 0;
      let lastFrameTime = window.performance.now();
      let isDragging = false;
      let activePointerId = null;
      let activeDragSpeed = 1;
      let dragStartX = 0;
      let dragStartPosition = 0;
      let touchIdentifier = null;
      let touchStartX = 0;
      let touchStartY = 0;
      let touchDirectionLocked = false;
      let touchIsHorizontal = false;

      const normalizePosition = () => {
        if (!cycleWidth) {
          return;
        }

        while (position <= -cycleWidth) position += cycleWidth;
        while (position > 0) position -= cycleWidth;
      };

      const renderPosition = () => {
        track.style.transform = `translate3d(${position}px, 0, 0)`;
      };

      const measureRail = () => {
        const nextCycleWidth = firstGroup.getBoundingClientRect().width;

        if (!Number.isFinite(nextCycleWidth) || nextCycleWidth <= 0) {
          return false;
        }

        const hadCycleWidth = cycleWidth > 0;
        cycleWidth = nextCycleWidth;

        if (!hadCycleWidth) {
          position = direction > 0 ? -cycleWidth + 0.5 : 0;
        }

        normalizePosition();
        renderPosition();

        return true;
      };

      const tick = (frameTime) => {
        const elapsedSeconds = Math.min(0.08, Math.max(0, frameTime - lastFrameTime) / 1000);
        lastFrameTime = frameTime;

        if (!isDragging && cycleWidth && !reduceMotion) {
          position += direction * speed * elapsedSeconds;
          normalizePosition();
          renderPosition();
        }

        window.requestAnimationFrame(tick);
      };

      const finishDrag = (event) => {
        if (!isDragging || event.pointerId !== activePointerId) {
          return;
        }

        isDragging = false;
        activePointerId = null;
        viewport.classList.remove("is-dragging");
        lastFrameTime = window.performance.now();

        try {
          viewport.releasePointerCapture(event.pointerId);
        } catch (error) {
          // The pointer may already be released by the browser.
        }
      };

      const finishTouchDrag = () => {
        if (isDragging && activePointerId === null) {
          isDragging = false;
          viewport.classList.remove("is-dragging");
          lastFrameTime = window.performance.now();
        }

        touchIdentifier = null;
        touchDirectionLocked = false;
        touchIsHorizontal = false;
      };

      const getTrackedTouch = (touches) => (
        Array.from(touches || []).find((touch) => touch.identifier === touchIdentifier) || null
      );

      track.dataset.previewRailReady = "true";
      track.classList.add("is-drag-ready");
      measureRail();

      viewport.addEventListener("pointerdown", (event) => {
        if (event.button !== undefined && event.button !== 0) {
          return;
        }

        if (!measureRail()) {
          return;
        }

        isDragging = true;
        activePointerId = event.pointerId;
        activeDragSpeed = event.pointerType === "touch" ? touchDragSpeed : dragSpeed;
        dragStartX = event.clientX;
        dragStartPosition = position;
        viewport.classList.add("is-dragging");

        try {
          viewport.setPointerCapture(event.pointerId);
        } catch (error) {
          // Pointer capture is a progressive enhancement for smoother dragging.
        }

        event.preventDefault();
      });

      viewport.addEventListener("pointermove", (event) => {
        if (!isDragging || event.pointerId !== activePointerId) {
          return;
        }

        position = dragStartPosition + (event.clientX - dragStartX) * activeDragSpeed;
        normalizePosition();
        renderPosition();
        event.preventDefault();
      });

      viewport.addEventListener("pointerup", finishDrag);
      viewport.addEventListener("pointercancel", finishDrag);
      viewport.addEventListener("lostpointercapture", finishDrag);
      viewport.addEventListener("touchstart", (event) => {
        if (isDragging || event.touches.length !== 1 || !measureRail()) {
          return;
        }

        const touch = event.touches[0];
        touchIdentifier = touch.identifier;
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        dragStartX = touch.clientX;
        dragStartPosition = position;
        touchDirectionLocked = false;
        touchIsHorizontal = false;
      }, { passive: true });

      viewport.addEventListener("touchmove", (event) => {
        if (touchIdentifier === null) {
          return;
        }

        const touch = getTrackedTouch(event.touches);

        if (!touch) {
          finishTouchDrag();
          return;
        }

        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;
        const absoluteX = Math.abs(deltaX);
        const absoluteY = Math.abs(deltaY);

        if (!touchDirectionLocked) {
          if (absoluteX < 6 && absoluteY < 6) {
            return;
          }

          touchDirectionLocked = true;
          touchIsHorizontal = absoluteX > absoluteY;

          if (!touchIsHorizontal) {
            touchIdentifier = null;
            return;
          }

          isDragging = true;
          activePointerId = null;
          viewport.classList.add("is-dragging");
        }

        if (!touchIsHorizontal) {
          return;
        }

        position = dragStartPosition + (touch.clientX - dragStartX) * touchDragSpeed;
        normalizePosition();
        renderPosition();
        event.preventDefault();
      }, { passive: false });

      viewport.addEventListener("touchend", (event) => {
        if (touchIdentifier !== null && getTrackedTouch(event.changedTouches)) {
          finishTouchDrag();
        }
      }, { passive: true });

      viewport.addEventListener("touchcancel", (event) => {
        if (touchIdentifier !== null && getTrackedTouch(event.changedTouches)) {
          finishTouchDrag();
        }
      }, { passive: true });
      track.addEventListener("dragstart", (event) => {
        event.preventDefault();
      });

      if ("ResizeObserver" in window) {
        const observer = new ResizeObserver(measureRail);
        observer.observe(firstGroup);
        observer.observe(viewport);
      } else {
        window.addEventListener("resize", measureRail);
      }

      if (document.readyState === "complete") {
        measureRail();
      } else {
        window.addEventListener("load", measureRail, { once: true });
      }

      window.requestAnimationFrame(tick);
    });
  };

  const setupProductMediaThumbnails = () => {
    const showcases = document.querySelectorAll("[data-product-media-showcase]");

    showcases.forEach((showcase) => {
      const mainImage = showcase.querySelector(".wp-world-cup-product-cover img");
      const thumbnails = Array.from(showcase.querySelectorAll("[data-product-thumb]"));

      if (!mainImage || !thumbnails.length) {
        return;
      }

      const setActiveThumbnail = (thumbnail) => {
        const nextSrc = thumbnail.dataset.productThumbSrc;

        if (!nextSrc) {
          return;
        }

        const nextSrcset = thumbnail.dataset.productThumbSrcset || "";
        const nextAlt = thumbnail.dataset.productThumbAlt || mainImage.alt;

        if (nextSrcset) {
          mainImage.srcset = nextSrcset;
        } else {
          mainImage.removeAttribute("srcset");
        }

        mainImage.src = nextSrc;
        mainImage.alt = nextAlt;

        thumbnails.forEach((otherThumbnail) => {
          if (otherThumbnail === thumbnail) {
            otherThumbnail.setAttribute("aria-current", "true");
          } else {
            otherThumbnail.removeAttribute("aria-current");
          }
        });
      };

      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener("click", () => {
          setActiveThumbnail(thumbnail);
        });
      });
    });
  };

  const setupFaqAccordions = () => {
    const faqGroups = document.querySelectorAll(".wp-faq__list, [data-faq-accordion]");

    faqGroups.forEach((faqGroup) => {
      const items = Array.from(faqGroup.querySelectorAll("details"));
      let firstOpenItem = null;

      items.forEach((item) => {
        if (item.open) {
          if (firstOpenItem) {
            item.open = false;
          } else {
            firstOpenItem = item;
          }
        }

        item.addEventListener("toggle", () => {
          if (!item.open) {
            return;
          }

          items.forEach((otherItem) => {
            if (otherItem !== item) {
              otherItem.open = false;
            }
          });
        });
      });
    });
  };

  const setupSpamGuards = () => {
    const guardedForms = document.querySelectorAll(".js-spam-guard");

    guardedForms.forEach((form) => {
      const spamField = form.querySelector("[data-spam-field]");
      const readyAt = Date.now() + 1200;

      form.addEventListener("submit", (event) => {
        const spamValue = spamField && spamField.value ? spamField.value.trim() : "";

        if (spamValue || Date.now() < readyAt) {
          event.preventDefault();
          event.stopImmediatePropagation();

          if (spamField) {
            spamField.value = "";
          }
        }
      });
    });
  };

  const setupCartRemovalConfirmation = () => {
    const form = document.querySelector('[data-cart-form]');
    const dialog = document.querySelector('[data-cart-remove-dialog]');
    if (!form || !dialog) return;
    const cancelButton = dialog.querySelector('[data-cart-remove-cancel]');
    let pending = null;
    let opener = null;
    let confirmed = false;
    const askToRemove = (items, trigger, accept, cancel = () => {}) => {
      if (pending) return;
      const title = items.length === 1 ? 'Vil du fjerne denne boken?' : 'Vil du fjerne disse bøkene?';
      if (typeof dialog.showModal !== 'function') {
        if (window.confirm(`${title}\n\n${items.join('\n')}`)) accept();
        else cancel();
        return;
      }
      opener = trigger;
      pending = { accept, cancel };
      dialog.querySelector('[data-cart-remove-title]').textContent = title;
      dialog.querySelector('[data-cart-remove-items]').replaceChildren(...items.map((name) => {
        const item = document.createElement('li'); item.textContent = name; return item;
      }));
      dialog.showModal();
      cancelButton.focus({ preventScroll: true });
    };
    const handleRemove = (event) => {
      const link = event.target.closest('[data-cart-remove]');
      if (!link || (event.type === 'auxclick' && event.button !== 1)) return;
      event.preventDefault();
      askToRemove([link.closest('[data-cart-item]').dataset.cartItemTitle], link, () => window.location.assign(link.href));
    };
    form.addEventListener('click', handleRemove);
    form.addEventListener('auxclick', handleRemove);
    form.addEventListener('submit', (event) => {
      if (confirmed) return;
      const removed = [...form.querySelectorAll('[data-cart-quantity]')].filter((input) => input.valueAsNumber === 0);
      if (!removed.length) return;
      event.preventDefault();
      const submitter = event.submitter;
      askToRemove(removed.map((input) => input.closest('[data-cart-item]').dataset.cartItemTitle), submitter || removed[0], () => {
        confirmed = true;
        try {
          if (submitter) submitter.click();
          else if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
        } finally { confirmed = false; }
      }, () => removed.forEach((input) => { input.value = input.dataset.originalQuantity; }));
    });
    cancelButton.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {
      pending?.cancel();
      pending = null;
      opener?.focus({ preventScroll: true });
    });
    dialog.querySelector('[data-cart-remove-confirm]').addEventListener('click', () => {
      const action = pending;
      if (!action) return;
      pending = null;
      dialog.close();
      action.accept();
    });
    form.querySelectorAll('[data-cart-remove]').forEach((link) => link.setAttribute('aria-haspopup', 'dialog'));
  };

  const setupBookSearch = () => {
    const modal = document.querySelector('[data-book-search-modal]');
    if (!modal) return;
    const section = modal.querySelector('[data-book-search]');
    const input = section.querySelector('[data-book-search-input]');
    const results = section.querySelector('[data-book-search-results]');
    const status = section.querySelector('[data-book-search-status]');
    const empty = section.querySelector('[data-book-search-empty]');
    const clear = section.querySelector('[data-book-search-clear]');
    // Shopify can briefly serve old HTML alongside a newly versioned script.
    // Upgrade missing controls before binding events, so that combination stays usable.
    let actions = section.querySelector('.wp-search-actions');
    if (!actions) {
      actions = document.createElement('div');
      actions.className = 'wp-search-actions';
      results.insertAdjacentElement('afterend', actions);
    }
    const action = (attribute, tag, label) => {
      let element = section.querySelector(`[${attribute}]`);
      if (!element) {
        element = document.createElement(tag);
        element.setAttribute(attribute, '');
        element.className = tag === 'button' ? 'wp-search-more' : 'wp-text-link';
        if (tag === 'button') element.type = 'button';
        element.textContent = label;
        element.hidden = true;
        actions.append(element);
      }
      return element;
    };
    const more = action('data-book-search-more', 'button', 'Vis flere bøker');
    const retry = action('data-book-search-retry', 'button', 'Prøv igjen');
    const allResults = action('data-book-search-all', 'a', 'Se alle treff');
    if (!section.dataset.bookSearchCatalogEndpoint) {
      section.dataset.bookSearchCatalogEndpoint = '/collections/all';
      const script = document.currentScript;
      if (script?.src && !document.querySelector('link[href*="norway-header-search-20261011.css"]')) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = new URL('norway-header-search-20261011.css', script.src).href;
        document.head.append(link);
      }
    }
    const chips = Array.from(section.querySelectorAll('[data-book-search-chip]'));
    const legacyTerms = {'fotball-vm': 'fotball', dad: 'pappa', laeringshistorier: 'avslutning', fairy: 'feer', horse: 'hester', bursdagsboker: 'bursdag'};
    chips.forEach(chip => {
      if (legacyTerms[chip.dataset.searchTerm]) chip.dataset.searchTerm = legacyTerms[chip.dataset.searchTerm];
      if (chip.dataset.searchTerm === 'fotball') chip.textContent = 'Fotball';
    });
    const links = document.querySelectorAll('[data-book-search-link]');
    const touchSearch = window.matchMedia('(max-width: 759px), (pointer: coarse)');
    const initialCards = Array.from(results.querySelectorAll('[data-book-search-card]'));
    const ensureTitle = card => {
      if (card.querySelector('h3')) return;
      const media = card.querySelector('a[aria-label]');
      if (!media) return;
      const title = document.createElement('h3'), link = document.createElement('a');
      title.className = 'wp-search-card__title';
      link.href = media.href;
      link.textContent = media.getAttribute('aria-label');
      title.append(link);
      card.querySelector('.wp-book-card__artwork').insertAdjacentElement('afterend', title);
    };
    initialCards.forEach(ensureTitle);
    const defaultCount = Number(section.dataset.bookSearchDefaultCount || 4);
    const pageSize = 12;
    let catalog = null, catalogPromise = null, matches = [], shown = 0;
    let requestId = 0, timer = null, composing = false;
    let previousFocus = null, savedScroll = null, savedBody = null;
    const normalizeSearchValue = value => value.toLowerCase().replace(/ø/g, 'o').replace(/æ/g, 'ae')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    const isOpen = () => !modal.hidden;

    // Norway Search measurement: report completed book-finder searches through the existing tag.
    let searchTrackingTimer = null;
    const trackedSearches = new Set();
    const scheduleSearchTracking = (query) => {
      window.clearTimeout(searchTrackingTimer);
      const searchKey = normalizeSearchValue(query);
      if (searchKey.length < 2 || trackedSearches.has(searchKey)) return;
      const renderedRequest = requestId;
      searchTrackingTimer = window.setTimeout(() => {
        try {
          if (!isOpen() || renderedRequest !== requestId || trackedSearches.has(searchKey)) return;
          if (!['eventyrhelten.no', 'www.eventyrhelten.no'].includes(window.location.hostname)) return;
          const privacy = window.Shopify?.customerPrivacy;
          // The native API includes the visitor's choice and the store's regional rules.
          if (typeof privacy?.marketingAllowed !== 'function' || !privacy.marketingAllowed()) return;
          if (typeof window.gtag !== 'function') return;
          window.gtag('event', 'conversion', {
            send_to: 'AW-18469417250/YiUrCLP3kJcdEKLi8-ZE',
            value: 1,
            currency: 'NOK'
          });
          trackedSearches.add(searchKey);
        } catch (error) {
          // Measurement must never interrupt searching; no tag or consent is created here.
        }
      }, 750);
    };
    // End Norway Search measurement.
    const focusWithoutKeyboard = () => section.focus({preventScroll: true});
    const updateViewport = () => {
      if (!isOpen()) return;
      const viewport = window.visualViewport;
      modal.style.setProperty('--wp-search-height', `${viewport ? viewport.height : window.innerHeight}px`);
      modal.style.setProperty('--wp-search-top', `${viewport ? viewport.offsetTop : 0}px`);
    };
    const open = () => {
      if (isOpen()) return;
      previousFocus = document.activeElement;
      closeMobileMenu();
      savedScroll = {x: window.scrollX, y: window.scrollY};
      savedBody = {};
      ['position', 'top', 'left', 'width', 'paddingRight'].forEach(key => {savedBody[key] = document.body.style[key];});
      const scrollbar = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
      if (scrollbar) document.body.style.paddingRight = `${parseFloat(getComputedStyle(document.body).paddingRight) + scrollbar}px`;
      document.body.style.position = 'fixed';
      document.body.style.top = `${-savedScroll.y}px`;
      document.body.style.left = `${-savedScroll.x}px`;
      document.body.style.width = '100%';
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('wp-search-modal-open');
      links.forEach(link => link.setAttribute('aria-expanded', 'true'));
      updateViewport();
      section.querySelector('.wp-book-finder__inner').scrollTop = 0;
      // Touch users choose when to open the keyboard. Desktop users can type immediately.
      window.requestAnimationFrame(() => {if (isOpen()) (touchSearch.matches ? section : input).focus({preventScroll: true});});
    };
    const close = () => {
      if (!isOpen()) return;
      window.clearTimeout(searchTrackingTimer);
      if (modal.contains(document.activeElement)) document.activeElement.blur();
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('wp-search-modal-open');
      links.forEach(link => link.setAttribute('aria-expanded', 'false'));
      Object.keys(savedBody || {}).forEach(key => {document.body.style[key] = savedBody[key];});
      if (savedScroll) window.scrollTo({left: savedScroll.x, top: savedScroll.y, behavior: 'instant'});
      if (previousFocus && previousFocus.isConnected) previousFocus.focus({preventScroll: true});
    };
    const updateControls = () => {
      const normalized = normalizeSearchValue(input.value);
      clear.hidden = !input.value;
      chips.forEach(chip => {
        const active = normalized === normalizeSearchValue(chip.dataset.searchTerm || chip.textContent);
        chip.classList.toggle('is-active', active);
        chip.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      more.hidden = true;
      retry.hidden = true;
      allResults.hidden = true;
    };
    const render = (nextMatches, query, count = pageSize) => {
      matches = nextMatches;
      shown = Math.min(count, matches.length);
      results.replaceChildren(...matches.slice(0, shown));
      matches.slice(0, shown).forEach(card => {card.hidden = false;});
      results.setAttribute('aria-busy', 'false');
      empty.hidden = !query || matches.length > 0;
      more.hidden = !query || shown >= matches.length;
      more.textContent = `Vis flere bøker (${matches.length - shown})`;
      status.textContent = !query ? 'Utvalgte bøker' : shown < matches.length
        ? `Viser ${shown} av ${matches.length} bøker som passer`
        : `${matches.length} ${matches.length === 1 ? 'bok' : 'bøker'} som passer`;
      scheduleSearchTracking(query);
    };
    const getCatalog = () => {
      if (catalog) return Promise.resolve(catalog);
      if (catalogPromise) return catalogPromise;
      catalogPromise = (async () => {
        let url = new URL(section.dataset.bookSearchCatalogEndpoint, window.location.origin);
        url.searchParams.set('section_id', 'wonderpods-book-search-catalog');
        const seen = new Set(), cards = [], handles = new Set();
        while (url) {
          if (url.origin !== window.location.origin || seen.has(url.href)) throw new Error('Invalid book catalog page');
          seen.add(url.href);
          const response = await window.fetch(url.href, {headers: {'X-Requested-With': 'XMLHttpRequest'}});
          if (!response.ok) throw new Error('Book catalog unavailable');
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const page = parsed.querySelector('[data-book-search-catalog]');
          if (!page) throw new Error('Book catalog missing');
          page.querySelectorAll('[data-book-search-card]').forEach(card => {
            const handle = card.dataset.searchHandle;
            if (!handle || handles.has(handle)) return;
            handles.add(handle);
            ensureTitle(card);
            card._searchPrimary = normalizeSearchValue(card.dataset.searchPrimary || '');
            card._searchTerms = normalizeSearchValue(card.dataset.searchTerms || '');
            card._searchTitle = normalizeSearchValue(card.querySelector('h3')?.textContent || '');
            cards.push(card);
          });
          const next = page.dataset.nextPage;
          url = next ? new URL(next, window.location.origin) : null;
          if (url) url.searchParams.set('section_id', 'wonderpods-book-search-catalog');
        }
        if (!cards.length) throw new Error('Empty book catalog');
        catalog = cards;
        return cards;
      })().finally(() => {catalogPromise = null;});
      return catalogPromise;
    };
    const findMatches = (cards, value) => {
      const query = normalizeSearchValue(value);
      // Age matching uses the store's actual age bands, including their endpoints.
      const age = query.match(/\b(\d{1,2})(?:\s+(\d{1,2}))?\s+(?:ar|aar|year|years)\b/);
      const tokens = (age ? query.replace(age[0], '') : query).split(' ').filter(Boolean);
      const variants = token => token === 'feer' ? ['feer', 'feen', 'skogfe', 'tannfe', 'febok']
        : ['hester', 'hesten'].includes(token) ? ['hest'] : token === 'dinosaurer' ? ['dinosaur'] : [token];
      const matchWords = terms => tokens.every(token => variants(token).some(word => terms.includes(word)));
      const eligible = cards.filter(card => {
        if (!age) return true;
        const from = Number(age[1]), to = Number(age[2] || age[1]);
        return Array.from((card.dataset.searchAges || '').matchAll(/age:(\d+)-(\d+)/g))
          .some(band => from >= Number(band[1]) && to <= Number(band[2]));
      });
      const primary = eligible.filter(card => matchWords(card._searchPrimary));
      const found = primary.length ? primary : eligible.filter(card => matchWords(card._searchTerms));
      return found.sort((a, b) => Number(b._searchTitle === query) - Number(a._searchTitle === query));
    };
    const remoteFallback = async (value, id) => {
      const url = new URL(section.dataset.bookSearchEndpoint || '/search', window.location.origin);
      url.searchParams.set('q', value); // Keep Norwegian letters in the actual Shopify query.
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      const allUrl = url.href;
      url.searchParams.set('section_id', section.dataset.bookSearchSectionId);
      const response = await window.fetch(url.href, {headers: {'X-Requested-With': 'XMLHttpRequest'}});
      if (!response.ok) throw new Error('Book search unavailable');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const page = parsed.querySelector('[data-book-search-rendered-results]');
      if (!page) throw new Error('Book search missing');
      if (id !== requestId) return;
      const cards = Array.from(page.querySelectorAll('[data-book-search-card]'));
      cards.forEach(ensureTitle);
      render(cards, value, cards.length);
      const total = Number(page.dataset.totalCount || cards.length);
      if (total > cards.length) {
        status.textContent = `Viser ${cards.length} av ${total} bøker som passer`;
        allResults.href = allUrl;
        allResults.hidden = false;
      }
    };
    const search = async (value, id) => {
      try {
        const cards = await getCatalog();
        if (id !== requestId) return;
        render(findMatches(cards, value), value);
      } catch (error) {
        if (id !== requestId) return;
        try {await remoteFallback(value, id);}
        catch (fallbackError) {
          if (id !== requestId) return;
          results.replaceChildren();
          results.setAttribute('aria-busy', 'false');
          empty.hidden = true;
          status.textContent = 'Boksøket er midlertidig utilgjengelig. Prøv igjen.';
          retry.hidden = false;
        }
      }
    };
    const update = (immediate = false) => {
      requestId += 1; // Invalidate old responses as soon as the user changes the query.
      window.clearTimeout(searchTrackingTimer);
      const id = requestId, value = input.value.trim();
      section.querySelector('.wp-book-finder__inner').scrollTop = 0;
      window.clearTimeout(timer);
      updateControls();
      if (!value) {render(initialCards.slice(0, defaultCount), '', defaultCount);return;}
      empty.hidden = true;
      results.replaceChildren();
      results.setAttribute('aria-busy', 'true');
      status.textContent = 'Søker etter bøker…';
      if (immediate) search(value, id);
      else timer = window.setTimeout(() => search(value, id), 180);
    };
    input.disabled = false;
    input.addEventListener('compositionstart', () => {composing = true;window.clearTimeout(timer);requestId += 1;});
    input.addEventListener('compositionend', () => {composing = false;update();});
    input.addEventListener('input', () => {if (!composing) update();});
    section.querySelector('[data-book-search-form]').addEventListener('submit', event => {
      event.preventDefault();
      update(true);
      if (touchSearch.matches) {input.blur();focusWithoutKeyboard();}
    });
    clear.addEventListener('click', () => {
      input.value = '';
      update(true);
      if (!touchSearch.matches) input.focus({preventScroll: true});
      else focusWithoutKeyboard();
    });
    chips.forEach(chip => chip.addEventListener('click', () => {
      const term = chip.dataset.searchTerm || chip.textContent.trim();
      input.value = normalizeSearchValue(input.value) === normalizeSearchValue(term) ? '' : term;
      input.blur();
      update(true);
      chip.focus({preventScroll: true});
    }));
    more.addEventListener('click', () => {
      const previousShown = shown;
      render(matches, input.value.trim(), shown + pageSize);
      if (more.hidden) results.children[previousShown]?.querySelector('h3 a, a[href]')?.focus({preventScroll: true});
    });
    retry.addEventListener('click', () => update(true));
    document.addEventListener('visitorConsentCollected', () => {
      if (isOpen() && results.getAttribute('aria-busy') === 'false') scheduleSearchTracking(input.value.trim());
    });
    links.forEach(link => link.addEventListener('click', event => {event.preventDefault();open();}));
    modal.querySelectorAll('[data-book-search-close]').forEach(button => button.addEventListener('click', close));
    modal.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !event.isComposing) {event.preventDefault();close();return;}
      if (event.key !== 'Tab') return;
      const focusable = Array.from(section.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]'))
        .filter(el => el.offsetWidth || el.offsetHeight);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (!first) {event.preventDefault();focusWithoutKeyboard();}
      else if (event.shiftKey && (document.activeElement === first || document.activeElement === section)) {event.preventDefault();last.focus();}
      else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first.focus();}
    });
    window.visualViewport?.addEventListener('resize', updateViewport);
    window.visualViewport?.addEventListener('scroll', updateViewport);
    window.addEventListener('resize', updateViewport);
    update(true);
    if (window.location.hash === '#book-finder') {
      if (document.readyState === 'complete') open();
      else window.addEventListener('load', open, {once: true});
    }
  };

  const setupPersonalizeButtonWaves = () => {
    const desktopHover = window.matchMedia("(hover: hover) and (pointer: fine)");
    const selector = '.wp-button--personalize:not(:disabled):not([aria-disabled="true"])';
    let previousPoint = null;

    document.addEventListener("pointermove", (event) => {
      if (event.pointerType !== "mouse") return;
      previousPoint = desktopHover.matches ? { x: event.clientX, y: event.clientY } : null;
    }, { passive: true });

    document.addEventListener("pointerout", (event) => {
      if (event.pointerType === "mouse" && !event.relatedTarget) previousPoint = null;
    }, { passive: true });

    // Delegation also covers cards added later by search, saved books, or the account drawer.
    document.addEventListener("pointerover", (event) => {
      if (event.pointerType !== "mouse" || !desktopHover.matches) return;
      const button = event.target.closest?.(selector);
      if (!button || button.contains(event.relatedTarget) || button.matches(":focus-visible")) return;

      const rect = button.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const edges = [
        ["left", Math.abs(event.clientX - rect.left)],
        ["right", Math.abs(rect.right - event.clientX)],
        ["top", Math.abs(event.clientY - rect.top)],
        ["bottom", Math.abs(rect.bottom - event.clientY)]
      ];
      let [entry] = edges.reduce((nearest, edge) => edge[1] < nearest[1] ? edge : nearest);
      const isInside = (point) => point.x >= rect.left && point.x <= rect.right && point.y >= rect.top && point.y <= rect.bottom;
      const currentPoint = { x: event.clientX, y: event.clientY };
      if (previousPoint && !isInside(previousPoint) && isInside(currentPoint)) {
        const dx = currentPoint.x - previousPoint.x;
        const dy = currentPoint.y - previousPoint.y;
        const xEntry = dx ? ((dx > 0 ? rect.left : rect.right) - previousPoint.x) / dx : -Infinity;
        const yEntry = dy ? ((dy > 0 ? rect.top : rect.bottom) - previousPoint.y) / dy : -Infinity;
        // The last boundary crossed is the entry edge when a fast move begins diagonally outside.
        entry = xEntry >= yEntry ? (dx > 0 ? "left" : "right") : (dy > 0 ? "top" : "bottom");
      }

      // Establish the new offscreen start before transitioning, including rapid re-entry.
      button.setAttribute("data-personalize-wave-reset", "");
      button.setAttribute("data-personalize-entry", entry);
      window.getComputedStyle(button, "::before").transform;
      button.removeAttribute("data-personalize-wave-reset");
    }, { passive: true });
  };

  const setupCollectionPreloads = () => {
    const preloadLinks = Array.from(document.querySelectorAll("[data-collection-preload-link]"));

    if (!preloadLinks.length) {
      return;
    }

    const requestedImages = new Set();
    const prefetchedDocuments = new Set();
    const imageBudget = 6;

    const normalizeUrl = (url) => {
      try {
        const parsedUrl = new URL(url, window.location.href);
        parsedUrl.hash = "";
        return parsedUrl.toString();
      } catch (error) {
        return url;
      }
    };

    const prefetchDocument = (url) => {
      const normalizedUrl = normalizeUrl(url);

      if (!normalizedUrl || prefetchedDocuments.size >= 2 || prefetchedDocuments.has(normalizedUrl) || normalizedUrl === normalizeUrl(window.location.href)) {
        return;
      }

      prefetchedDocuments.add(normalizedUrl);

      const link = document.createElement("link");
      link.rel = "prefetch";
      link.as = "document";
      link.fetchPriority = "low";
      link.href = normalizedUrl;
      document.head.appendChild(link);
    };

    const preloadCollectionLink = (link) => {
      if (!canPreloadImages()) return;
      const imageUrls = (link.dataset.preloadImages || "")
        .split("|")
        .map((url) => url.trim())
        .filter(Boolean)
        .slice(0, 2);

      imageUrls.forEach((url) => {
        const normalizedUrl = normalizeUrl(url);
        if (requestedImages.has(normalizedUrl) || requestedImages.size >= imageBudget) return;
        requestedImages.add(normalizedUrl);
        preloadImage({ src: normalizedUrl });
      });

      prefetchDocument(link.href);
    };

    preloadLinks.forEach((link) => {
      let intentTimer;
      const cancelWarm = () => window.clearTimeout(intentTimer);
      const warmFocusedCollection = () => {
        cancelWarm();
        intentTimer = window.setTimeout(() => preloadCollectionLink(link), 150);
      };

      link.addEventListener("pointerenter", (event) => {
        if (event.pointerType !== "touch") warmFocusedCollection();
      });
      link.addEventListener("pointerleave", cancelWarm);
      link.addEventListener("focus", warmFocusedCollection);
      link.addEventListener("blur", cancelWarm);
    });
  };

  if (document.readyState === "complete") {
    scheduleOfferPopup();
  } else {
    window.addEventListener("load", scheduleOfferPopup, { once: true });
  }

  setupHeroCarousel();
  setupProductHeroMediaRotators();
  setupProductVariantPricing();
  setupWorldCupCountryPickers();
  setupProductStickyAtc();
  setupWorldCupHorizontalGestureLock();
  setupWorldCupBallAnimation();
  setupWorldCupExampleFaders();
  setupWorldCupPreviewRails();
  setupProductMediaThumbnails();
  setupFaqAccordions();
  setupSpamGuards();


  setupHorizontalRailControls();


  setupCartRemovalConfirmation();
  setupBookSearch();
  setupPersonalizeButtonWaves();
  setupCollectionPreloads();

  if (document.readyState === "complete") {
    setupWorldCupBallAnimation();
  } else {
    window.addEventListener("load", setupWorldCupBallAnimation, { once: true });
  }

  if (mobileMenu) {
    mobileMenu.addEventListener("click", (event) => {
      const link = event.target.closest("a");

      if (link) {
        closeMobileMenu();
      }
    });
  }

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeMobileMenu();
      hideOfferPopup();
      hideRareOffer();
    }
  });

  if (offerPopup && offerClose) {
    offerClose.addEventListener("click", hideOfferPopup);
  }

  // Keep the signup and its feedback visible once a visitor starts interacting.
  ["pointerdown", "focusin", "input", "submit"].forEach((eventName) => {
    if (offerPopup) offerPopup.addEventListener(eventName, holdOfferPopup, true);
    if (rareOffer) rareOffer.addEventListener(eventName, holdRareOffer, true);
  });

  rareOfferCloseButtons.forEach((button) => {
    button.addEventListener("click", hideRareOffer);
  });

})();
